import React, { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell,Legend } from 'recharts';
import { 
  TrendingUp, TrendingDown, Users, Send, MessageSquare, AlertTriangle, Target, Star, Building2, 
  Filter, X, User, Mail, Activity, Award, ChevronDown, ChevronUp, ChevronRight,
  Heart, Briefcase, Settings, Download, Share2, BarChart3, FileText, Eye, PieChart as PieChartIcon
} from 'lucide-react';  


const VDartSatisfactionDashboard = () => {
  const [selectedFilter, setSelectedFilter] = useState({
    bu: 'All',
    department: 'All',
    period: 'All'
  });
  
  const [selectedDetailType, setSelectedDetailType] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedSurveyQuestion, setSelectedSurveyQuestion] = useState(null);
  const [selectedView, setSelectedView] = useState('overview');
  const [selectedRating, setSelectedRating] = useState(null);
  const [selectedFunctionType, setSelectedFunctionType] = useState('All');
  const [expandedQuestion, setExpandedQuestion] = useState(null);
  const [expandedResponse, setExpandedResponse] = useState(null);


  // Real data from Excel file - 251 records
  
    const realExcelData = [
      { "Status": "Survey Responded", "Email": "SaadS1@hexaware.com", "First Name": "Saad", "Last Name": "Siddiqi", "Client": "Hexaware", "Function": "TAG", "BU": "Oliver", "understanding": "5 - star", "quality": "4 - star", "speed": "4 - star", "partnership": "4 - star", "communication": "3 - star", "npsScore": 7 },
      { "Status": "Survey Responded", "Email": "uganesan@altimetrik.com", "First Name": "Udhaya", "Last Name": "Ganesan", "Client": "Altimetrik", "Function": "TAG", "BU": "Oliver", "understanding": "4 - star", "quality": "4 - star", "speed": "5 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 9 },
      { "Status": "Survey Responded", "Email": "bbritto@altimetrik.com", "First Name": "Benjamin", "Last Name": "Britto", "Client": "Altimetrik", "Function": "TAG", "BU": "Oliver", "understanding": "5 - star", "quality": "5 - star", "speed": "5 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 9 },
      { "Status": "Survey Responded", "Email": "ravi.raja@trianz.com", "First Name": "Ravishankaran", "Last Name": "Raja", "Client": "Trianz", "Function": "TAG Lead", "BU": "Oliver", "understanding": "5 - star", "quality": "4 - star", "speed": "4 - star", "partnership": "4 - star", "communication": "4 - star", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "hemalatha.r@trianz.com", "First Name": "Hemalatha", "Last Name": "Rajagopalan", "Client": "Trianz", "Function": "TAG Lead", "BU": "Oliver", "understanding": "5 - star", "quality": "5 - star", "speed": "4 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "rakeshs3@hexaware.com", "First Name": "Rakesh", "Last Name": "Saini", "Client": "Hexaware", "Function": "TAG", "BU": "Oliver", "understanding": "5 - star", "quality": "5 - star", "speed": "5 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "kalpanas@hexaware.com", "First Name": "Kalpana", "Last Name": "Som", "Client": "Hexaware", "Function": "TAG", "BU": "Oliver", "understanding": "4 - star", "quality": "3 - star", "speed": "3 - star", "partnership": "3 - star", "communication": "4 - star", "npsScore": 8 },
      { "Status": "Survey Responded", "Email": "MonikaS6@hexaware.com", "First Name": "Monika", "Last Name": "Sonawane", "Client": "Hexaware", "Function": "TAG", "BU": "Oliver", "understanding": "4 - star", "quality": "4 - star", "speed": "4 - star", "partnership": "4 - star", "communication": "4 - star", "npsScore": 8 },
      { "Status": "Survey Responded", "Email": "lalit.bhardwaj@genpact.com", "First Name": "Lalit", "Last Name": "Bhardwaj", "Client": "Genpact", "Function": "Hiring Manager", "BU": "Oliver", "understanding": "5 - star", "quality": "5 - star", "speed": "5 - star", "partnership": "4 - star", "communication": "5 - star", "npsScore": 9 },
      { "Status": "Survey Responded", "Email": "anuj.jain@tredence.com", "First Name": "Anuj", "Last Name": "Jain", "Client": "Tredence", "Function": "TAG", "BU": "Oliver", "understanding": "4 - star", "quality": "4 - star", "speed": "3 - star", "partnership": "4 - star", "communication": "4 - star", "npsScore": 7 },
      { "Status": "Survey Responded", "Email": "divya.sn@trianz.com", "First Name": "Divya", "Last Name": "Sn", "Client": "Trianz", "Function": "TAG Lead", "BU": "Oliver", "understanding": "5 - star", "quality": "4 - star", "speed": "4 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 8 },
      { "Status": "Survey Responded", "Email": "Gopinath.S@itcinfotech.com", "First Name": "Gopinath", "Last Name": "S", "Client": "ITC - Infotech", "Function": "TAG", "BU": "Oliver", "understanding": "5 - star", "quality": "5 - star", "speed": "4 - star", "partnership": "4 - star", "communication": "5 - star", "npsScore": 9 },
      { "Status": "Survey Responded", "Email": "GajawadaV2@hexaware.com", "First Name": "Vishwanath", "Last Name": "Gajawada", "Client": "Hexaware", "Function": "TAG", "BU": "Oliver", "understanding": "4 - star", "quality": "4 - star", "speed": "3 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 9 },
      { "Status": "Survey Responded", "Email": "harshit.tiwari@tredence.com", "First Name": "Harshit", "Last Name": "Tiwari", "Client": "Tredence", "Function": "TAG Lead", "BU": "Oliver", "understanding": "5 - star", "quality": "4 - star", "speed": "4 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 9 },
      { "Status": "Survey Responded", "Email": "inP@hexaware.com", "First Name": "Prasanna", "Last Name": "Kumar", "Client": "Hexaware", "Function": "TAG", "BU": "Oliver", "understanding": "5 - star", "quality": "5 - star", "speed": "4 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 9 },
      { "Status": "Survey Responded", "Email": "manishk4@hexaware.com", "First Name": "Manish", "Last Name": "", "Client": "Hexaware", "Function": "TAG", "BU": "Oliver", "understanding": "5 - star", "quality": "5 - star", "speed": "5 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 9 },
      { "Status": "Survey Responded", "Email": "AniteshS@hexaware.com", "First Name": "Anitesh", "Last Name": "Singh", "Client": "Hexaware", "Function": "TAG", "BU": "Oliver", "understanding": "5 - star", "quality": "5 - star", "speed": "5 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "ArunPrasad.A@cognizant.com", "First Name": "ArunPrasad", "Last Name": "Arockiasamy", "Client": "CTS", "Function": "TAG Lead", "BU": "Oliver", "understanding": "5 - star", "quality": "4 - star", "speed": "4 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "Bhavani.santhanam@apexon.com", "First Name": "Bhavani", "Last Name": "Bhavani", "Client": "Apexon", "Function": "TAG", "BU": "Oliver", "understanding": "5 - star", "quality": "5 - star", "speed": "5 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "Vijaykumar.Sundarraj@ust.com", "First Name": "Vijaykumar", "Last Name": "Sundarraj", "Client": "UST", "Function": "TAG", "BU": "Oliver", "understanding": "5 - star", "quality": "5 - star", "speed": "5 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "Vinay.Kumar2@ust.com", "First Name": "Vinay", "Last Name": "Kumar", "Client": "UST", "Function": "TAG", "BU": "Oliver", "understanding": "5 - star", "quality": "4 - star", "speed": "4 - star", "partnership": "3 - star", "communication": "5 - star", "npsScore": 9 },
      { "Status": "Survey Responded", "Email": "shivj@hexaware.com", "First Name": "Shiv", "Last Name": "Jain", "Client": "Hexaware", "Function": "TAG", "BU": "Oliver", "understanding": "5 - star", "quality": "5 - star", "speed": "5 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 9 },
      { "Status": "Survey Responded", "Email": "pradeep_n@persistent.com", "First Name": "Pradeep", "Last Name": "N", "Client": "Persistent", "Function": "Hiring Manager", "BU": "Oliver", "understanding": "5 - star", "quality": "5 - star", "speed": "5 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "Ankaraju.Yelisetti@genpact.com", "First Name": "Ankaraju", "Last Name": "Yelisetti", "Client": "Genpact", "Function": "Hiring Manager", "BU": "Oliver", "understanding": "5 - star", "quality": "5 - star", "speed": "5 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "Arunpandian.Palpandi@ust.com", "First Name": "Arunpandian", "Last Name": "Palpandi", "Client": "UST", "Function": "TAG Lead", "BU": "Oliver", "understanding": "2 - star", "quality": "3 - star", "speed": "1 - star", "partnership": "2 - star", "communication": "3 - star", "npsScore": 6 },
      { "Status": "Survey Responded", "Email": "Arathi.Nandakumar@itcinfotech.com", "First Name": "Arathi", "Last Name": "Nandakumar", "Client": "ITC - Infotech", "Function": "TAG Lead", "BU": "Oliver", "understanding": "5 - star", "quality": "5 - star", "speed": "5 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "damodharan.mohan@apexon.com", "First Name": "Damodharan", "Last Name": "Mohan", "Client": "Apexon", "Function": "Procurement", "BU": "Oliver", "understanding": "NA", "quality": "NA", "speed": "NA", "partnership": "NA", "communication": "NA", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "SumitS9@hexaware.com", "First Name": "Sumit", "Last Name": "Srivastava", "Client": "Hexaware", "Function": "TAG", "BU": "Oliver", "understanding": "3 - star", "quality": "2 - star", "speed": "3 - star", "partnership": "2 - star", "communication": "3 - star", "npsScore": 6 },
      { "Status": "Survey Responded", "Email": "rajarshi@persistent.com", "First Name": "Rajarshi", "Last Name": "", "Client": "Persistent", "Function": "TAG Lead", "BU": "Oliver", "understanding": "4 - star", "quality": "4 - star", "speed": "3 - star", "partnership": "3 - star", "communication": "4 - star", "npsScore": 7 },
      { "Status": "Survey Responded", "Email": "nitins8@hexaware.com", "First Name": "Nitin", "Last Name": "Sohal", "Client": "Hexaware", "Function": "TAG", "BU": "Oliver", "understanding": "4 - star", "quality": "4 - star", "speed": "4 - star", "partnership": "3 - star", "communication": "4 - star", "npsScore": 7 },
      { "Status": "Survey Responded", "Email": "divya.singh01@tredence.com", "First Name": "Divya", "Last Name": "Singh", "Client": "Tredence", "Function": "TAG Lead", "BU": "Oliver", "understanding": "4 - star", "quality": "4 - star", "speed": "5 - star", "partnership": "4 - star", "communication": "5 - star", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "GauravkumarR@hexaware.com", "First Name": "Gaurav", "Last Name": "Kumar", "Client": "Hexaware", "Function": "TAG", "BU": "Oliver", "understanding": "1 - star", "quality": "2 - star", "speed": "2 - star", "partnership": "2 - star", "communication": "NA", "npsScore": null },
      { "Status": "Survey Responded", "Email": "sharmila.m@ust.com", "First Name": "Sharmila", "Last Name": "M", "Client": "UST", "Function": "Hiring Manager", "BU": "Oliver", "understanding": "2 - star", "quality": "2 - star", "speed": "2 - star", "partnership": "2 - star", "communication": "NA", "npsScore": null },
      { "Status": "Survey Responded", "Email": "karthik.deenadayalu@nexteraenergy.com", "First Name": "Karthik", "Last Name": "Deenadayalu", "Client": "NextEra Energy", "Function": "Hirirng Manager", "BU": "Rohit", "understanding": "4 - star", "quality": "3 - star", "speed": "3 - star", "partnership": "3 - star", "communication": "4 - star", "npsScore": 8 },
      { "Status": "Survey Responded", "Email": "Bablu12.Kumar@nttdata.com", "First Name": "Bablu", "Last Name": "Kumar", "Client": "NTT Data", "Function": "Procurement", "BU": "Rohit", "understanding": "NA", "quality": "NA", "speed": "NA", "partnership": "NA", "communication": "NA", "npsScore": 4 },
      { "Status": "Survey Responded", "Email": "Satyendra.Vishwakarma@nttdata.com", "First Name": "Satyendra", "Last Name": "Vishwakarma", "Client": "NTT Data", "Function": "Procurement", "BU": "Rohit", "understanding": "NA", "quality": "NA", "speed": "NA", "partnership": "NA", "communication": "NA", "npsScore": 8 },
      { "Status": "Survey Responded", "Email": "tstewart@wrkfrcsol.com", "First Name": "Taylar", "Last Name": "Stewart", "Client": "Hitachi", "Function": "Procurement", "BU": "Rohit", "understanding": "NA", "quality": "NA", "speed": "NA", "partnership": "NA", "communication": "NA", "npsScore": 8 },
      { "Status": "Survey Responded", "Email": "Gaurav.singhnegi@nttdata.com", "First Name": "Gaurav Singh", "Last Name": "Negi", "Client": "NTT Data", "Function": "Procurement", "BU": "Rohit", "understanding": "NA", "quality": "NA", "speed": "NA", "partnership": "NA", "communication": "NA", "npsScore": 8 },
      { "Status": "Survey Responded", "Email": "shanthi.bysani@accenture.com", "First Name": "Shanthi", "Last Name": "Bysani", "Client": "Accenture", "Function": "Procurement", "BU": "Rohit", "understanding": "NA", "quality": "NA", "speed": "NA", "partnership": "NA", "communication": "NA", "npsScore": 9 },
      { "Status": "Survey Responded", "Email": "Daniel.Crane@nttdata.com", "First Name": "Daniel", "Last Name": "Crane", "Client": "NTT Data", "Function": "Procurement", "BU": "Rohit", "understanding": "NA", "quality": "NA", "speed": "NA", "partnership": "NA", "communication": "NA", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "chandrashekar.maheshwaram@nttdata.com", "First Name": "Chandra Shekar", "Last Name": "Maheshwaram", "Client": "NTT Data", "Function": "Procurement", "BU": "Rohit", "understanding": "NA", "quality": "NA", "speed": "NA", "partnership": "NA", "communication": "NA", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "antonio.gomez@accenture.com", "First Name": "Antonio", "Last Name": "Gomez", "Client": "Accenture", "Function": "TAG Lead", "BU": "Rohit", "understanding": "4 - star", "quality": "4 - star", "speed": "4 - star", "partnership": "4 - star", "communication": "4 - star", "npsScore": 9 },
      { "Status": "Survey Responded", "Email": "umang.natani@nexteraenergy.com", "First Name": "Umang", "Last Name": "Natani", "Client": "NextEra Energy", "Function": "TAG", "BU": "Rohit", "understanding": "5 - star", "quality": "5 - star", "speed": "5 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "Taylor.Marshall@roberthalf.com", "First Name": "Taylor", "Last Name": "Marshall", "Client": "RHT", "Function": "TAG Lead", "BU": "Rohit", "understanding": "5 - star", "quality": "4 - star", "speed": "5 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "jaime.belton@roberthalf.com", "First Name": "Jaime", "Last Name": "Belton", "Client": "RHT", "Function": "TAG Lead", "BU": "Rohit", "understanding": "4 - star", "quality": "4 - star", "speed": "4 - star", "partnership": "4 - star", "communication": "4 - star", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "abigail.fox@roberthalf.com", "First Name": "Abigail", "Last Name": "Fox", "Client": "RHT", "Function": "TAG Lead", "BU": "Rohit", "understanding": "5 - star", "quality": "5 - star", "speed": "5 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 10 },
      { "Status": "Survey Responded", "Email": "mallaram.shashank@ltimindtree.com", "First Name": "Mallaram", "Last Name": "Shashank", "Client": "LTIMindtree", "Function": "TAG", "BU": "Nambu", "understanding": "4 - star", "quality": "4 - star", "speed": "3 - star", "partnership": "3 - star", "communication": "4 - star", "npsScore": 8 },
      { "Status": "Survey Responded", "Email": "vibin.joseph@ltts.com", "First Name": "Vibin Joseph", "Last Name": "Sagayaraj", "Client": "LTTS", "Function": "TAG", "BU": "Nambu", "understanding": "4 - star", "quality": "3 - star", "speed": "3 - star", "partnership": "4 - star", "communication": "5 - star", "npsScore": 9 },
      { "Status": "Survey Responded", "Email": "mandoz.samy@ltts.com", "First Name": "Mandoz Anthony", "Last Name": "SAMY", "Client": "LTTS", "Function": "TAG", "BU": "Nambu", "understanding": "4 - star", "quality": "4 - star", "speed": "2 - star", "partnership": "3 - star", "communication": "5 - star", "npsScore": 7 },
      { "Status": "Survey Responded", "Email": "mandhagolla.chakradhar@ltimindtree.com", "First Name": "Mandhagolla", "Last Name": "Chakradhar", "Client": "LTIMindtree", "Function": "TAG", "BU": "Nambu", "understanding": "5 - star", "quality": "5 - star", "speed": "4 - star", "partnership": "4 - star", "communication": "4 - star", "npsScore": 9 },
      { "Status": "Survey Responded", "Email": "Rana.Kundan@hcltech.com", "First Name": "Rana Kundan", "Last Name": "Singh", "Client": "HCL(CS)", "Function": "TAG", "BU": "Sidd", "understanding": "5 - star", "quality": "4 - star", "speed": "3 - star", "partnership": "3 - star", "communication": "5 - star", "npsScore": 7 },
      { "Status": "Survey Responded", "Email": "HKelly@hcltech.com", "First Name": "Helen", "Last Name": "Kelly", "Client": "HCL(DB)", "Function": "Procurement", "BU": "Sidd", "understanding": "NA", "quality": "NA", "speed": "NA", "partnership": "NA", "communication": "NA", "npsScore": 10 },
  { "Status": "Survey Responded", "Email": "haseeb.ma2@cox.com", "First Name": "Haseeb", "Last Name": "Ma", "Client": "Genpact", "Function": "Hiring Manager", "BU": "Oliver", "understanding": "5 - star", "quality": "5 - star", "speed": "5 - star", "partnership": "5 - star", "communication": "5 - star", "npsScore": 10 },    {
    "Status": "Survey Not responded",
    "Email": "Rashmi.Vernekar@ust.com",
    "First Name": "Rashmi",
    "Last Name": "Vernekar",
    "Client": "UST",
    "Function": "TAG",
    "BU": "Oliver",
    "understanding": "Survey Not responded",
    "quality": "Survey Not responded",
    "speed": "Survey Not responded",
    "partnership": "Survey Not responded",
    "communication": "Survey Not responded",
    "npsScore": null
  }
  ,
  
      {
          "Status": "Survey Not responded",
          "Email": "KuldeepR@hcltech.com",
          "First Name": "Kuldeep",
          "Last Name": "Singh Rawat",
          "Client": "HCL Infra",
          "Function": "TAG Lead",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "rajasekar_s@hcltech.com",
          "First Name": "RajaSekar",
          "Last Name": "S",
          "Client": "HCL Infra",
          "Function": "TAG Lead",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "asha.subramanian@hcltech.com",
          "First Name": "Asha",
          "Last Name": "Subramanian",
          "Client": "HCL Infra",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "abhaya.singh@hcltech.com",
          "First Name": "Abhaya Pratap",
          "Last Name": "Singh",
          "Client": "HCL Infra",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "rupak.verma@hcltech.com",
          "First Name": "Rupak",
          "Last Name": "Verma",
          "Client": "HCL Infra",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "devesh.pandey@hcltech.com",
          "First Name": "Devesh",
          "Last Name": "Pandey",
          "Client": "HCL Infra",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "jeniffer.s@hcltech.com",
          "First Name": "Jeniffer",
          "Last Name": "S",
          "Client": "HCL Infra",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "mohamed.anash@hcltech.com",
          "First Name": "Mohamed",
          "Last Name": "Anas",
          "Client": "HCL Infra",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "pravinkumar.singh@hcltech.com",
          "First Name": "Pravin Kumar",
          "Last Name": "Singh",
          "Client": "HCL Infra",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Taresh.M@hcltech.com",
          "First Name": "Taresh",
          "Last Name": "M",
          "Client": "HCL( DB)",
          "Function": "TAG Lead",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "achinnam@hcltech.com",
          "First Name": "Adam",
          "Last Name": "Newman Chinnam",
          "Client": "HCL( CI)",
          "Function": "TAG Lead",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "saumya.handa@hcltech.com",
          "First Name": "Saumya",
          "Last Name": "Handa",
          "Client": "HCL( CI)",
          "Function": "TAG Lead",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "sumit-c@hcltech.com",
          "First Name": "Sumit",
          "Last Name": "Chaudhry",
          "Client": "HCL(CI)",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "akash_w@hcltech.com",
          "First Name": "Akash",
          "Last Name": "Wadhwa",
          "Client": "HCL(CI)",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "u.utkarsh@hcltech.com",
          "First Name": "Utkarsh",
          "Last Name": "U",
          "Client": "HCL(CI)",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "siddhant_sa@hcltech.com",
          "First Name": "Siddhant",
          "Last Name": "Saxena",
          "Client": "HCL(CI)",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "neelam.batra@hcltech.com",
          "First Name": "Neelam",
          "Last Name": "Batra",
          "Client": "HCL( CS)",
          "Function": "TAG Lead",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "AkashSingh.Sengar@hcltech.com",
          "First Name": "Akash",
          "Last Name": "Sengar",
          "Client": "HCL( CS)",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "gaurav.sin@hcltech.com",
          "First Name": "Gaurav",
          "Last Name": "Singh",
          "Client": "HCL(CS)",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "richa.sharma@hcltech.com",
          "First Name": "Richa",
          "Last Name": "Sharma",
          "Client": "HCL(CS)",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Vishal.Purbey@hcltech.com",
          "First Name": "Vishal",
          "Last Name": "Purbey",
          "Client": "HCL(CS)",
          "Function": "TAG Lead",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "achal.g@hcltech.com",
          "First Name": "Achal",
          "Last Name": "Gupta",
          "Client": "HCL(CS)",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "vinodh.p@hcltech.com",
          "First Name": "Vinodh",
          "Last Name": "Pulangi",
          "Client": "HCL (FS)",
          "Function": "TAG Lead",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "mohitswaroop.kashiva@hcltech.com",
          "First Name": "Mohit",
          "Last Name": "Swaroop",
          "Client": "HCL(FS)",
          "Function": "TAG Lead",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "mahalakshme.sivan@hcltech.com",
          "First Name": "Mahalakshme",
          "Last Name": "Sivanantham",
          "Client": "HCL(FS)",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "himanshi-s@hcltech.com",
          "First Name": "Himanshi",
          "Last Name": "Shukla",
          "Client": "HCL(FS)",
          "Function": "TAG Lead",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "snigdha.bhattacharya@hcltech.com",
          "First Name": "Snigdha",
          "Last Name": "Bhattacharya",
          "Client": "HCL(FS)",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "yadav_a@hcltech.com",
          "First Name": "Alok",
          "Last Name": "Yadav",
          "Client": "HCL (FS)",
          "Function": "TAG Lead",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "SetuS@hcltech.com",
          "First Name": "Setu",
          "Last Name": "Sahay",
          "Client": "HCL(FS)",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "pawan-kumar1@hcltech.com",
          "First Name": "Pawan",
          "Last Name": "Kumar",
          "Client": "HCL(FS)",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "siddharth.t@hcltech.com",
          "First Name": "Siddharth",
          "Last Name": "Tiwari",
          "Client": "HCL(FS)",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Christina.Jones@hcltech.com",
          "First Name": "Christina",
          "Last Name": "Jones",
          "Client": "HCL (SAP)",
          "Function": "TAG Lead",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "shreyansh.dubey@hcltech.com",
          "First Name": "Shreyansh",
          "Last Name": "Dubey",
          "Client": "HCL (SAP)",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "bernabeconcep.galit@hcltech.com",
          "First Name": "Bernabe",
          "Last Name": "Galit",
          "Client": "HCL(SAP)",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "rambahadur.thakur@hcltech.com",
          "First Name": "Ram",
          "Last Name": "Thakur",
          "Client": "HCL Canada",
          "Function": "TAG Lead",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "casper.lin@hcltech.com",
          "First Name": "Casper",
          "Last Name": "Lin",
          "Client": "HCL Canada",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "sinuo.chen@hcltech.com",
          "First Name": "Nicole",
          "Last Name": "Chen",
          "Client": "HCL Canada",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "dominic.marsh@hcltech.com",
          "First Name": "Dominic",
          "Last Name": "Marsh",
          "Client": "HCL Canada",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "zaheed.shariff@hcltech.com",
          "First Name": "Zaheed",
          "Last Name": "Shariff",
          "Client": "HCL Canada",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "vishal-bhatt@hcltech.com",
          "First Name": "Vishal",
          "Last Name": "Bhatt",
          "Client": "HCL Canada",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "roba.raouf@hcltech.com",
          "First Name": "Roba",
          "Last Name": "Raouf",
          "Client": "HCL Canada",
          "Function": "TAG",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Percivalf@hcltech.com",
          "First Name": "Percival",
          "Last Name": "Fernandez",
          "Client": "HCL Canada",
          "Function": "TAG Lead",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "kenneth.kerrigan@hcltech.com",
          "First Name": "Ken",
          "Last Name": "Kerrigan",
          "Client": "HCL",
          "Function": "Procurement",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "brendan.mcgeough@hcltech.com",
          "First Name": "Brendan",
          "Last Name": "McGeough",
          "Client": "HCL",
          "Function": "Procurement",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "ritika-s@hcltech.com",
          "First Name": "Ritika",
          "Last Name": "Sharma",
          "Client": "HCL",
          "Function": "Procurement",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "shivangi.t@hcltech.com",
          "First Name": "Shivangi",
          "Last Name": "Tripathi",
          "Client": "HCL",
          "Function": "Procurement",
          "BU": "Sidd",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "anand.reddy@wpengine.com",
          "First Name": "Anand",
          "Last Name": "Reddy",
          "Client": "WP Engine",
          "Function": "TAG",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "mprendez@ari.tech",
          "First Name": "Melinda",
          "Last Name": "Prendez",
          "Client": "ARI Tech",
          "Function": "TAG Lead",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Suman.Sandhu@roberthalf.com",
          "First Name": "Suman",
          "Last Name": "Sandhu",
          "Client": "RHT",
          "Function": "TAG Lead",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Garrick.Beck@nttdata.com",
          "First Name": "Garrick",
          "Last Name": "Beck",
          "Client": "NTT Data",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "prateek.pawha@nttdata.com",
          "First Name": "Prateek",
          "Last Name": "Pawha",
          "Client": "NTT Data",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "praveen11.peteti@nttdata.com",
          "First Name": "Praveen",
          "Last Name": "Peteti",
          "Client": "NTT Data",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "utkarsh11.kaushik@nttdata.com",
          "First Name": "Utkarsh",
          "Last Name": "Kaushik",
          "Client": "NTT Data",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Naresh.Boni@nttdata.com",
          "First Name": "Naresh",
          "Last Name": "Boni",
          "Client": "NTT Data",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "bhaskar.mahaseth@nttdata.com",
          "First Name": "Bhaskar",
          "Last Name": "Mahaseth",
          "Client": "NTT Data",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "tania.daniel@databricks.com",
          "First Name": "Tania",
          "Last Name": "Daniel",
          "Client": "Databricks",
          "Function": "TAG Lead",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "pradeep.singh@databricks.com",
          "First Name": "Pradeep",
          "Last Name": "Singh",
          "Client": "Databricks",
          "Function": "TAG Lead",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "deepa.gopinath@databricks.com",
          "First Name": "Deepa",
          "Last Name": "Gopinath",
          "Client": "Databricks",
          "Function": "TAG Lead",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Brandon.Muchicko@magnitglobal.com",
          "First Name": "Brandon",
          "Last Name": "Muchicko",
          "Client": "Databricks",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "juliya.mukha@magnitglobal.com",
          "First Name": "Juliya",
          "Last Name": "Mukha",
          "Client": "Databricks",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "cindy.brushaber@southernco.com",
          "First Name": "Cindy",
          "Last Name": "Smith",
          "Client": "Southern Company",
          "Function": "TAG Lead",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "raqmille@southernco.com",
          "First Name": "Raquel",
          "Last Name": "Miller",
          "Client": "Southern Company",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "shalini.ganju@accenture.com",
          "First Name": "Shalini",
          "Last Name": "Ganju",
          "Client": "Accenture",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "patricia.boone@accenture.com",
          "First Name": "Patricia",
          "Last Name": "Boone",
          "Client": "Accenture",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "prasad.risbud@accenture.com",
          "First Name": "Prasad",
          "Last Name": "Risbud",
          "Client": "Accenture",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "kisa.a.pearson@accenture.com",
          "First Name": "Kisa",
          "Last Name": "Pearson",
          "Client": "Accenture",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Ben.Farakish@aesc-group.com",
          "First Name": "Ben",
          "Last Name": "Farakish",
          "Client": "AESC",
          "Function": "TAG Lead",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "robin.Lich@aesc-group.com",
          "First Name": "Robin",
          "Last Name": "Lich",
          "Client": "AESC",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "kyle.Kimmey@aesc-group.com",
          "First Name": "Kyle",
          "Last Name": "Kimmey",
          "Client": "AESC",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "john.mccabe@mrcooper.com",
          "First Name": "John",
          "Last Name": "McCabe",
          "Client": "Mr.Cooper",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "caitlin.Maguire@fortisconstruction.com",
          "First Name": "Caitlin",
          "Last Name": "Maguire",
          "Client": "Fortis",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "jdawkins@tcco.com",
          "First Name": "Jonathan",
          "Last Name": "Dawkins",
          "Client": "Turner Construtcion",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "abeitel@tcco.com",
          "First Name": "Andy",
          "Last Name": "Beitel",
          "Client": "Turner Construtcion",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Surinder.chopra@infosys.com",
          "First Name": "Surinder",
          "Last Name": "Chopra",
          "Client": "Infosys",
          "Function": "TAG Lead",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "nimisha.tripathi@infosys.com",
          "First Name": "Nimisha",
          "Last Name": "Tripathi",
          "Client": "Infosys",
          "Function": "TAG Lead",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "suraj.sriram@infosys.com",
          "First Name": "Suraj",
          "Last Name": "Sriram",
          "Client": "Infosys",
          "Function": "TAG",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "mreedy@wrkfrcsol.com",
          "First Name": "Mistie",
          "Last Name": "Reedy",
          "Client": "Hitachi",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "amanda.singleton@hitachi-digital.com",
          "First Name": "Amanda",
          "Last Name": "Singleton",
          "Client": "Hitachi",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "todd.robinson@hitachi-digital.com",
          "First Name": "Todd",
          "Last Name": "Robinson",
          "Client": "Hitachi",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "rohit.ranjan@hitachids.com",
          "First Name": "Rohit",
          "Last Name": "Ranjan",
          "Client": "Hitachi",
          "Function": "Hirirng Manager",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "mohit.tewari@hitachids.com",
          "First Name": "Mohit",
          "Last Name": "Tewari",
          "Client": "Hitachi",
          "Function": "Hirirng Manager",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Veeranna.Panjala@HitachiDS.com",
          "First Name": "Veeranna",
          "Last Name": "Panjala",
          "Client": "Hitachi",
          "Function": "Hirirng Manager",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Alex.Hopko@fpl.com",
          "First Name": "Alex",
          "Last Name": "Hopko",
          "Client": "NextEra Energy",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Amy.Wiegand@fpl.com",
          "First Name": "Amy",
          "Last Name": "Wiegand",
          "Client": "NextEra Energy",
          "Function": "Procurement",
          "BU": "Rohit",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "saravanan.moorthy@ltts.com",
          "First Name": "Saravanan",
          "Last Name": "Moorthy",
          "Client": "LTTS",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Shipra.Gupta@Ltts.com",
          "First Name": "Shipra",
          "Last Name": "Gupta",
          "Client": "LTTS",
          "Function": "TAG Lead",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "KRISHNAVENI.PADMANABHAN@Ltts.com",
          "First Name": "Krishnaveni",
          "Last Name": "PADMANBHAN",
          "Client": "LTTS",
          "Function": "TAG Lead",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Thomas.Smith@LTTS.com",
          "First Name": "Thomas",
          "Last Name": "Smith",
          "Client": "LTTS",
          "Function": "TAG Lead",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Frank.Henry@ltts.com",
          "First Name": "Frank",
          "Last Name": "Henry",
          "Client": "LTTS",
          "Function": "TAG Lead",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Malika.Kotian@Ltts.com",
          "First Name": "Malika",
          "Last Name": "Koitain",
          "Client": "LTTS",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Bryant.Cox@Ltts.com",
          "First Name": "Bryant",
          "Last Name": "Cox",
          "Client": "LTTS",
          "Function": "TAG Lead",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Neetu.Mishra@LTTS.COM",
          "First Name": "Neetu",
          "Last Name": "Mishara",
          "Client": "LTTS",
          "Function": "TAG Lead",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Siva.Theja@ltts.com",
          "First Name": "Siva Teja",
          "Last Name": "Bankapuri",
          "Client": "LTTS",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Pruthvi.B@Ltts.com",
          "First Name": "Prudhvi",
          "Last Name": NaN,
          "Client": "LTTS",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "vinayaka.sn@ltts.com",
          "First Name": "Vinayaka",
          "Last Name": "SN",
          "Client": "LTTS",
          "Function": "Procurement",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Prakash.Krishnamoorthy@ltts.com",
          "First Name": "Prakash",
          "Last Name": "Krishnamoorthy",
          "Client": "LTTS",
          "Function": "TAG Lead",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "uthayakumar.nagarajan@ltimindtree.com",
          "First Name": "Uthayakumar",
          "Last Name": "Nagarajan",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "karthik.sivakumar@ltimindtree.com",
          "First Name": "Karthik",
          "Last Name": "Sivakumar",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Santhana.Bharathi@ltimindtree.com",
          "First Name": "Santhana",
          "Last Name": "Bharathi",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Arunkumar.Raju@ltimindtree.com",
          "First Name": "Arunkumar",
          "Last Name": "Raju",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Vimal.V@ltimindtree.com",
          "First Name": "Vimal",
          "Last Name": "Vivek",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Premkumar.K@ltimindtree.com",
          "First Name": "Prem Kumar",
          "Last Name": "Kasi",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "MohanRaj.N2@ltimindtree.com",
          "First Name": "Mohan",
          "Last Name": "Raj",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "SandeepKumar.Akula@ltimindtree.com",
          "First Name": "Sandeep Kumar",
          "Last Name": "Akula",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "varun1.verma@ltimindtree.com",
          "First Name": "Varun",
          "Last Name": "Verma",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "chanda.kakara@ltimindtree.com",
          "First Name": "Chanda",
          "Last Name": "Kakara",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "ramachandra.reddy1@ltimindtree.com",
          "First Name": "Ramachandra",
          "Last Name": "Reddy",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Jeyaseelan.J@ltimindtree.com",
          "First Name": "Jeyaseelan",
          "Last Name": "Joseph",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "amit.ahlawat@ltimindtree.com",
          "First Name": "Amit",
          "Last Name": "Ahlawat",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "melvin.irudayarajm@ltimindtree.com",
          "First Name": "Melvin",
          "Last Name": "Irudayaraj",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Anjali.Mehra@ltimindtree.com",
          "First Name": "Anjali",
          "Last Name": "Mehra",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Saurabh.Kumar7@ltimindtree.com",
          "First Name": "Saurabh",
          "Last Name": "Kumar",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Mayana.Khan@ltimindtree.com",
          "First Name": "Mayana Akram",
          "Last Name": "Ali Khan",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Udaybhan.Chauhan@ltimindtree.com",
          "First Name": "Udaybhan",
          "Last Name": "Chauhan",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Swetha.Gopal@ltimindtree.com",
          "First Name": "Swetha",
          "Last Name": "Gopal",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Visakan@ltimindtree.com",
          "First Name": "Visakan",
          "Last Name": "Kamaraj",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Aditya3.Singh@ltimindtree.com",
          "First Name": "Aditya",
          "Last Name": "Singh",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "abdul.mohammad@ltimindtree.com",
          "First Name": "Abdul Shamsheer",
          "Last Name": "Mohammad",
          "Client": "LTIMindtree",
          "Function": "TAG Lead",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "sunil.sivadasa@ltimindtree.com",
          "First Name": "Sunil",
          "Last Name": "Sivadasa",
          "Client": "LTIMindtree",
          "Function": "TAG Lead",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "sukanya.mukund@ltimindtree.com",
          "First Name": "Sukanya",
          "Last Name": "Mukund",
          "Client": "LTIMindtree",
          "Function": "TAG Lead",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "padmakar.shet@ltimindtree.com",
          "First Name": "Padmakar",
          "Last Name": "Shet",
          "Client": "LTIMindtree",
          "Function": "TAG Lead",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "geetanjali.adhikari@ltimindtree.com",
          "First Name": "Geetanjali",
          "Last Name": "Adhikari",
          "Client": "LTIMindtree",
          "Function": "TAG Lead",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "asha.shetty@ltimindtree.com",
          "First Name": "Asha",
          "Last Name": "Shetty",
          "Client": "LTIMindtree",
          "Function": "TAG Lead",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Anitha.Asrani@ltimindtree.com",
          "First Name": "Anitha",
          "Last Name": "Asrani",
          "Client": "LTIMindtree",
          "Function": "TAG Lead",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "pramod.pawar@ltimindtree.com",
          "First Name": "Pramod",
          "Last Name": "Pawar",
          "Client": "LTIMindtree",
          "Function": "Global Head",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "jijo.pallai@ltimindtree.com",
          "First Name": "Jijo",
          "Last Name": "Pallai",
          "Client": "LTIMindtree",
          "Function": "Procurement",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "radha.singh@ltimindtree.com",
          "First Name": "Radha",
          "Last Name": "Singh",
          "Client": "LTIMindtree",
          "Function": "Procurement",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "joseph.sham2@ltimindtree.com",
          "First Name": "Joesph",
          "Last Name": "Sham",
          "Client": "LTIMindtree",
          "Function": "Procurement",
          "BU": "Nambu",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "vijay.singh@apexon.com",
          "First Name": "Vijay",
          "Last Name": "Singh",
          "Client": "Apexon",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "shantanu.giri@apexon.com",
          "First Name": "Shantanu",
          "Last Name": "Giri",
          "Client": "Apexon",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "sameer.thakre@apexon.com",
          "First Name": "Sameer",
          "Last Name": "Thakre",
          "Client": "Apexon",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "murugesh.srinivasan@apexon.com",
          "First Name": "Murugesh",
          "Last Name": "Srinivasan",
          "Client": "Apexon",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "muthu.kombiah@apexon.com",
          "First Name": "Muthu",
          "Last Name": "Kombiah",
          "Client": "Apexon",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Sharon.Martis@apexon.com",
          "First Name": "Mischelle",
          "Last Name": "Martis",
          "Client": "Apexon",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "manoj.kumar@apexon.com",
          "First Name": "Manoj",
          "Last Name": "Kumar",
          "Client": "Apexon",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "gunjan.jha@apexon.com",
          "First Name": "Gunjan",
          "Last Name": "Jha",
          "Client": "Apexon",
          "Function": "Procurement",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Kalyanaraman.natarajan@cognizant.com",
          "First Name": "Kalyanaraman",
          "Last Name": "Natarajan",
          "Client": "CTS",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "sathya.r4@cognizant.com",
          "First Name": "Sathya",
          "Last Name": "R",
          "Client": "CTS",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "brittany.gaus@cognizant.com",
          "First Name": "Brittany",
          "Last Name": "Gaus",
          "Client": "CTS (Hays)",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "kylia.russell@cognizant.com",
          "First Name": "Kylia",
          "Last Name": "Russell",
          "Client": "CTS (Hays)",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "medicine.lee@cognizant.com",
          "First Name": "Medicine",
          "Last Name": "Lee",
          "Client": "CTS (Hays)",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Amanda.Bledsoe@cognizant.com",
          "First Name": "Amanda",
          "Last Name": "Bledsoe",
          "Client": "CTS (Hays)",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "kristin.soderberg@cognizant.com",
          "First Name": "Kristin",
          "Last Name": "Soderberg",
          "Client": "CTS (Hays)",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Jordan.Meissner@cognizant.com",
          "First Name": "Jordan",
          "Last Name": "Meissner",
          "Client": "CTS (Hays)",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "amy.sexsmith@cognizant.com",
          "First Name": "Amy",
          "Last Name": "Sexsmith",
          "Client": "CTS (Hays)",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "tana.church@cognizant.com",
          "First Name": "Tana",
          "Last Name": "Church",
          "Client": "CTS (Hays)",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Jon.Wolfson@cognizant.com",
          "First Name": "Jon",
          "Last Name": "Wolfson",
          "Client": "CTS (Hays)",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "devendrak3@hexaware.com",
          "First Name": "Devender",
          "Last Name": "Kumar",
          "Client": "Hexaware",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "utsavt1@hexaware.com",
          "First Name": "Utsav",
          "Last Name": "Tiwari",
          "Client": "Hexaware",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "dineshp9@hexaware.com",
          "First Name": "Dinesh",
          "Last Name": "Pandey",
          "Client": "Hexaware",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "amits18@hexaware.com",
          "First Name": "Amit",
          "Last Name": "Singh",
          "Client": "Hexaware",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "SachinB5@hexaware.com",
          "First Name": "Sachin",
          "Last Name": "Bhardwaj",
          "Client": "Hexaware",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "lalita.thapa@apexon.com",
          "First Name": "Lalita",
          "Last Name": "Thapa",
          "Client": "Apexon",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "RajanN@hexaware.com",
          "First Name": "Rajan",
          "Last Name": "Nagendra",
          "Client": "Hexaware",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "SureshL1@hexaware.com",
          "First Name": "Suresh",
          "Last Name": "Lankalapalli",
          "Client": "Hexaware",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "bhaveshp@hexaware.com",
          "First Name": "Bhavesh",
          "Last Name": "Pathak",
          "Client": "Hexaware",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "AshutoshS5@hexaware.com",
          "First Name": "Ashutosh",
          "Last Name": "Sharma",
          "Client": "Hexaware",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "KavinkumarK2@hexaware.com",
          "First Name": "Kavin",
          "Last Name": "Kumar",
          "Client": "Hexaware",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "PrasathM1@hexaware.com",
          "First Name": "Prasath",
          "Last Name": "Mathiyalagan",
          "Client": "Hexaware",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "PraneethB@hexaware.com",
          "First Name": "Praneeth",
          "Last Name": "Bondugulapati",
          "Client": "Hexaware",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "RakshanaS1@hexaware.com",
          "First Name": "Rakshana",
          "Last Name": "Subramanian",
          "Client": "Hexaware",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "UtkarshS2@hexaware.com",
          "First Name": "Utkarsh",
          "Last Name": "Agarwal",
          "Client": "Hexaware",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "annapoornas@hexaware.com",
          "First Name": "Annapoorna",
          "Last Name": "Shetty",
          "Client": "Hexaware",
          "Function": "Procurement",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Tuhina.Purohit@itcinfotech.com",
          "First Name": "Tuhina",
          "Last Name": "Purohit",
          "Client": "ITC - Infotech",
          "Function": "TAG Lead",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "NavaKishore.Kotni@itcinfotech.com",
          "First Name": "NavaKishore",
          "Last Name": "Kotni",
          "Client": "ITC - Infotech",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Subhajit.Chakraborty@itcinfotech.com",
          "First Name": "Subhajit",
          "Last Name": "Chakraborty",
          "Client": "ITC - Infotech",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "bharath_veluru@persistent.com",
          "First Name": "Bharath",
          "Last Name": "Veluru",
          "Client": "Persistent",
          "Function": "Hiring Manager",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Shafak_Pathan@persistent.com",
          "First Name": "Shafak",
          "Last Name": "Pathan",
          "Client": "Persistent",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "shanmugam_n@persistent.com",
          "First Name": "Shanmugam",
          "Last Name": "N",
          "Client": "Persistent",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "puja_kumari@persistent.com",
          "First Name": "Puja",
          "Last Name": "Kumari",
          "Client": "Persistent",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "lissa.parnell@cognizant.com",
          "First Name": "Lissa",
          "Last Name": "Parnell",
          "Client": "CTS (Hays)",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Katrina.Olmstead@cognizant.com",
          "First Name": "Katrina",
          "Last Name": "Olmstead",
          "Client": "CTS (Hays)",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Preeti.Kaur@tredence.com",
          "First Name": "Preeti",
          "Last Name": "Kaur",
          "Client": "Tredence",
          "Function": "TAG Lead",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "aamir.malik@tredence.com",
          "First Name": "Aamir",
          "Last Name": "Shafi",
          "Client": "Tredence",
          "Function": "Hiring Manager",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "asha.malviya@tredence.com",
          "First Name": "Asha",
          "Last Name": "Malviya",
          "Client": "Tredence",
          "Function": "TAG Lead",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "saba.rah@tredence.com",
          "First Name": "Saba",
          "Last Name": "Akhtar",
          "Client": "Tredence",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "sameer.chhabriya@tredence.com",
          "First Name": "Sameer",
          "Last Name": "Chhabriya",
          "Client": "Tredence",
          "Function": "TAG Lead",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Vimal.Vijay@ust.com",
          "First Name": "Vimal",
          "Last Name": "Vijay",
          "Client": "UST",
          "Function": "TAG Lead",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Krishna.Kanna@ust.com",
          "First Name": "Krishna",
          "Last Name": "Kanna",
          "Client": "UST",
          "Function": "Hiring Manager",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Debasish.Bhattacharjee@ust.com",
          "First Name": "Debasish",
          "Last Name": "Bhattacharjee",
          "Client": "UST",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Abhijith.Sureshkumar@ust.com",
          "First Name": "Abhijith",
          "Last Name": "Sureshkumar",
          "Client": "UST",
          "Function": "TAG Lead",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Prateek.pranjal@ust.com",
          "First Name": "Prateek",
          "Last Name": "Pranjal",
          "Client": "UST",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Ishan.Salaria@ust.com",
          "First Name": "Ishan",
          "Last Name": "Salaria",
          "Client": "UST",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "savitha.suresh@ust.com",
          "First Name": "Savitha",
          "Last Name": "Suresh",
          "Client": "UST",
          "Function": "TAG Lead",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
      {
          "Status": "Survey Not responded",
          "Email": "Mahesh.Gidwani@ust.com",
          "First Name": "Mahesh",
          "Last Name": "Gidwani",
          "Client": "UST",
          "Function": "TAG",
          "BU": "Oliver",
          "understanding": "Survey Not responded",
          "quality": "Survey Not responded",
          "speed": "Survey Not responded",
          "partnership": "Survey Not responded",
          "communication": "Survey Not responded",
          "npsScore": null
      },
     
  
      {
          "Status": "Technical issue",
          "Email": "PRichards@shccares.com",
          "First Name": "Peggy",
          "Last Name": "Richards",
          "Client": "Southern Company [Supplemental Staffing]",
          "Function": "TAG Lead",
          "BU": "Rohit",
          "reason": "Survey Cannot be completed"
      },
      {
          "Status": "Technical issue",
          "Email": "CMcKenzie@shccares.com",
          "First Name": "Christie",
          "Last Name": "McKenzie",
          "Client": "Southern Company [Supplemental Staffing]",
          "Function": "TAG Lead",
          "BU": "Rohit",
          "reason": "Survey Cannot be completed"
      },
      {
          "Status": "Technical issue",
          "Email": "HNeedham@shccares.com",
          "First Name": "H\u00e9l\u00e8ne",
          "Last Name": "Thompson",
          "Client": "Southern Company [Supplemental Staffing]",
          "Function": "TAG",
          "BU": "Rohit",
          "reason": "Survey Cannot be completed"
      },
      {
          "Status": "Technical issue",
          "Email": "jfarist@tesla.com",
          "First Name": "Ryan",
          "Last Name": "Farist",
          "Client": "Tesla",
          "Function": "Procurement",
          "BU": "Rohit",
          "reason": "Survey Cannot be completed"
      },
      {
          "Status": "Technical issue",
          "Email": "dtaborgaclaure@tesla.com",
          "First Name": "Daniela",
          "Last Name": "Claure",
          "Client": "Tesla",
          "Function": "Procurement",
          "BU": "Rohit",
          "reason": "Survey Cannot be completed"
      },
      {
          "Status": "Technical issue",
          "Email": "gaurav_joshi@infosys.com",
          "First Name": "Gaurav",
          "Last Name": "Joshi",
          "Client": "Infosys",
          "Function": "TAG Lead",
          "BU": "Rohit",
          "reason": "Survey Cannot be completed"
      },
      {
          "Status": "Technical issue",
          "Email": "sarah.cox@randstadsourceright.com",
          "First Name": "Sarah",
          "Last Name": "Cox",
          "Client": "Randstad for Allstate",
          "Function": "Procurement",
          "BU": "Rohit",
          "reason": "Survey Bounced"
      },
      {
          "Status": "Technical issue",
          "Email": "Livia.Gjinaj@cognizant.com",
          "First Name": "Livia",
          "Last Name": "Gjinaj",
          "Client": "CTS (Hays)",
          "Function": "TAG",
          "BU": "Oliver",
          "reason": "Survey Bounced"
      },
      {
          "Status": "Technical issue",
          "Email": "Visakan@ltimindtree.com",
          "First Name": "Visakan",
          "Last Name": "Kamaraj",
          "Client": "LTIMindtree",
          "Function": "TAG Lead",
          "BU": "Oliver",
          "reason": "Survey Cannot be completed"
      },
      {
          "Status": "Technical issue",
          "Email": "Premkumar.K@ltimindtree.com",
          "First Name": "Premkumar",
          "Last Name": "Kasi",
          "Client": "LTIMindtree",
          "Function": "TAG Lead",
          "BU": "Oliver",
          "reason": "Survey Cannot be completed"
      },
      {
          "Status": "Technical issue",
          "Email": "Arunkumar.Raju@ltimindtree.com",
          "First Name": "Arunkumar",
          "Last Name": "Raju",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Oliver",
          "reason": "Survey Cannot be completed"
      },
      {
          "Status": "Technical issue",
          "Email": "MohanRaj.N2@ltimindtree.com",
          "First Name": "Mohanraj",
          "Last Name": "Nair",
          "Client": "LTIMindtree",
          "Function": "TAG",
          "BU": "Oliver",
          "reason": "Survey Cannot be completed"
      }
      
      // Non-responders with realistic data distribution
      // ...Array.from({ length: 59 }, (_, i) => ({
      //   "Status": "Survey Not responded",
      //   "Email": `oliver.contact${i + 1}@client.com`,
      //   "First Name": `Oliver Contact ${i + 1}`,
      //   "Last Name": `Non Responder`,
      //   "Client": i < 20 ? "Hexaware" : i < 35 ? "Apexon" : i < 45 ? "CTS" : "UST",
      //   "Function": i < 30 ? "TAG" : i < 45 ? "TAG Lead" : "Hiring Manager",
      //   "BU": "Oliver"
      // })),
      
      // ...Array.from({ length: 37 }, (_, i) => ({
      //   "Status": "Survey Not responded",
      //   "Email": `rohit.contact${i + 1}@client.com`,
      //   "First Name": `Rohit Contact ${i + 1}`,
      //   "Last Name": `Non Responder`,
      //   "Client": i < 15 ? "NTT Data" : i < 25 ? "Accenture" : "NextEra Energy",
      //   "Function": i < 20 ? "Procurement" : i < 30 ? "TAG Lead" : "TAG",
      //   "BU": "Rohit"
      // })),
      
      // ...Array.from({ length: 44 }, (_, i) => ({
      //   "Status": "Survey Not responded",
      //   "Email": `nambu.contact${i + 1}@client.com`,
      //   "First Name": `Nambu Contact ${i + 1}`,
      //   "Last Name": `Non Responder`,
      //   "Client": i < 30 ? "LTIMindtree" : "LTTS",
      //   "Function": i < 25 ? "TAG" : "TAG Lead",
      //   "BU": "Nambu"
      // })),
      
      // ...Array.from({ length: 45 }, (_, i) => ({
      //   "Status": "Survey Not responded",
      //   "Email": `sidd.contact${i + 1}@client.com`,
      //   "First Name": `Sidd Contact ${i + 1}`,
      //   "Last Name": `Non Responder`,
      //   "Client": i < 30 ? "HCL Infra" : "HCL(CS)",
      //   "Function": i < 25 ? "TAG" : i < 35 ? "TAG Lead" : "Procurement",
      //   "BU": "Sidd"
      // }))
    ];
    
    const surveyQuestions = {
      'How well does VDart understand your staffing requirements and expectations?': {
        shortTitle: 'Understanding of Requirements',
        question: 'How well does VDart understand your staffing requirements and expectations?'
      },
      'How would you rate the overall quality of candidates VDart has provided?': {
        shortTitle: 'Candidate Quality',
        question: 'How would you rate the overall quality of candidates VDart has provided?'
      },
      'How satisfied are you with VDart\'s speed in delivering candidates for your open roles?': {
        shortTitle: 'Delivery Speed',
        question: 'How satisfied are you with VDart\'s speed in delivering candidates for your open roles?'
      },
      'How effectively does VDart act as a strategic hiring partner rather than just a service provider?': {
        shortTitle: 'Strategic Partnership',
        question: 'How effectively does VDart act as a strategic hiring partner rather than just a service provider?'
      },
      'How would you rate the responsiveness and communication of your VDart client Partner?': {
        shortTitle: 'Communication & Responsiveness',
        question: 'How would you rate the responsiveness and communication of your VDart client Partner?'
      },
      'How likely is it that you would recommend VDart to a friend or colleague?': {
        shortTitle: 'Net Promoter Score',
        question: 'How likely is it that you would recommend VDart to a friend or colleague?'
      },
      'In the past quarter, have you faced any challenges or difficulties while working with VDart?': {
        shortTitle: 'Challenges Faced',
        question: 'In the past quarter, have you faced any challenges or difficulties while working with VDart?'
      },
      'In the past 3 months, how frequently has your VDart client partner proactively checked in with you?': {
        shortTitle: 'Partner Check-ins',
        question: 'In the past 3 months, how frequently has your VDart client partner proactively checked in with you?'
      },
      'Are you satisfied with your current VDart client partner, or would you prefer a change?': {
        shortTitle: 'Partner Satisfaction',
        question: 'Are you satisfied with your current VDart client partner, or would you prefer a change?'
      },
      'Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?': {
        shortTitle: 'Vendor Ranking',
        question: 'Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?'
      },
      'Would you be interested in exploring additional services offered by VDart beyond staffing solutions?': {
        shortTitle: 'Additional Services Interest',
        question: 'Would you be interested in exploring additional services offered by VDart beyond staffing solutions?'
      }
    };
  


  // Function to normalize function names (group TAG,   TAG Lead, Hiring Manager as Tag Lead)
  const normalizeFunction = (func) => {
    if (func === 'TAG' || func === 'TAG Lead' || func === 'Hiring Manager' || func === 'Hirirng Manager') {
      return 'Tag Lead';
    }
    return 'Procurement';
  };

  const getFilteredData = () => {
    let filteredData = realExcelData;
    
    if (selectedFilter.bu !== 'All') {
      filteredData = filteredData.filter(record => record.BU === selectedFilter.bu);
    }

    if (selectedFilter.department !== 'All') {
      filteredData = filteredData.filter(record => {
        const normalizedFunction = normalizeFunction(record.Function);
        return normalizedFunction === selectedFilter.department;
      });
    }

    if (selectedFunctionType !== 'All') {
      filteredData = filteredData.filter(record => {
        const normalizedFunction = normalizeFunction(record.Function);
        return normalizedFunction === selectedFunctionType;
      });
    }

    const totalSent = filteredData.length;
    const completed = filteredData.filter(r => r.Status === 'Survey Responded').length;
    const nonResponders = filteredData.filter(r => r.Status === 'Survey Not responded').length;
    const technicalIssues = filteredData.filter(r => r.Status === 'Technical issue').length;
    const responseRate = totalSent > 0 ? ((completed / totalSent) * 100) : 0;

    return {
      totalSurveySent: totalSent,
      totalSurveyReceived: completed,
      totalNonResponders: nonResponders,
      totalTechnicalIssues: technicalIssues,
      responseRate: responseRate,
      data: filteredData
    };
  };

  const getClientWiseData = () => {
    const clientAnalysis = {};
    
    realExcelData.forEach(record => {
      if (!clientAnalysis[record.Client]) {
        clientAnalysis[record.Client] = {
          totalSent: 0,
          completed: 0,
          nonResponders: 0,
          technicalIssues: 0
        };
      }
      
      clientAnalysis[record.Client].totalSent++;
      
      if (record.Status === 'Survey Responded') {
        clientAnalysis[record.Client].completed++;
      } else if (record.Status === 'Survey Not responded') {
        clientAnalysis[record.Client].nonResponders++;
      } else if (record.Status === 'Technical issue') {
        clientAnalysis[record.Client].technicalIssues++;
      }
    });

    Object.values(clientAnalysis).forEach(data => {
      data.responseRate = data.totalSent > 0 ? (data.completed / data.totalSent) * 100 : 0;
    });

    return clientAnalysis;
  };

  const getBuFunctionAnalysis = () => {
    const analysis = {};
    
    realExcelData.forEach(record => {
      const normalizedFunction = normalizeFunction(record.Function);
      const key = `${record.BU}-${normalizedFunction}`;
      
      if (!analysis[key]) {
        analysis[key] = {
          bu: record.BU,
          function: normalizedFunction,
          totalSent: 0,
          surveyCompleted: 0,
          nonResponders: 0,
          technicalIssues: 0
        };
      }
      
      analysis[key].totalSent++;
      
      if (record.Status === 'Survey Responded') {
        analysis[key].surveyCompleted++;
      } else if (record.Status === 'Survey Not responded') {
        analysis[key].nonResponders++;
      } else if (record.Status === 'Technical issue') {
        analysis[key].technicalIssues++;
      }
    });

    Object.values(analysis).forEach(data => {
      data.responseRate = data.totalSent > 0 ? (data.surveyCompleted / data.totalSent) * 100 : 0;
    });

    return analysis;
  };

  const getFunctionWiseData = () => {
    const functionAnalysis = {};
    
    realExcelData.forEach(record => {
      const normalizedFunction = normalizeFunction(record.Function);
      
      if (!functionAnalysis[normalizedFunction]) {
        functionAnalysis[normalizedFunction] = {
          completed: 0,
          nonResponders: 0,
          technicalIssues: 0
        };
      }
      
      if (record.Status === 'Survey Responded') {
        functionAnalysis[normalizedFunction].completed++;
      } else if (record.Status === 'Survey Not responded') {
        functionAnalysis[normalizedFunction].nonResponders++;
      } else if (record.Status === 'Technical issue') {
        functionAnalysis[normalizedFunction].technicalIssues++;
      }
    });

    return Object.entries(functionAnalysis).map(([func, data]) => ({
      name: func,
      completed: data.completed,
      'Non-Responders': data.nonResponders,
      'Technical Issues': data.technicalIssues
    }));
  };

  const getDetailedResponses = (detailType) => {
    const currentData = getFilteredData();
    return currentData.data.filter(record => record.Status === detailType);
  };

  const calculateQuestionStats = () => {
    const currentData = getFilteredData();
    const surveyResponded = currentData.data.filter(r => r.Status === 'Survey Responded');

    const questionAnalysis = {
      "How well does VDart understand your staffing requirements and expectations?": {
        shortTitle: "Understanding of Requirements",
        responses: { "5 - star": 0, "4 - star": 0, "3 - star": 0, "2 - star": 0, "1 - star": 0, "NA": 0 }
      },
      "How would you rate the overall quality of candidates VDart has provided?": {
        shortTitle: "Candidate Quality",
        responses: { "5 - star": 0, "4 - star": 0, "3 - star": 0, "2 - star": 0, "1 - star": 0, "NA": 0 }
      },
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": {
        shortTitle: "Delivery Speed",
        responses: { "5 - star": 0, "4 - star": 0, "3 - star": 0, "2 - star": 0, "1 - star": 0, "NA": 0 }
      },
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": {
        shortTitle: "Strategic Partnership",
        responses: { "5 - star": 0, "4 - star": 0, "3 - star": 0, "2 - star": 0, "1 - star": 0, "NA": 0 }
      },
      "How would you rate the responsiveness and communication of your VDart client Partner?": {
        shortTitle: "Communication & Responsiveness",
        responses: { "5 - star": 0, "4 - star": 0, "3 - star": 0, "2 - star": 0, "1 - star": 0, "NA": 0 }
      },
      "How likely is it that you would recommend VDart to a friend or colleague?": {
        shortTitle: "Net Promoter Score",
        responses: { "10": 0, "9": 0, "8": 0, "7": 0, "6": 0, "5": 0, "4": 0, "3": 0, "2": 0, "1": 0, "0": 0 }
      }
    };

    surveyResponded.forEach(record => {
      if (record.understanding && record.understanding !== 'Not Answered') {
        questionAnalysis["How well does VDart understand your staffing requirements and expectations?"].responses[record.understanding]++;
      }
      if (record.quality && record.quality !== 'Not Answered') {
        questionAnalysis["How would you rate the overall quality of candidates VDart has provided?"].responses[record.quality]++;
      }
      if (record.speed && record.speed !== 'Not Answered') {
        questionAnalysis["How satisfied are you with VDart's speed in delivering candidates for your open roles?"].responses[record.speed]++;
      }
      if (record.partnership && record.partnership !== 'Not Answered') {
        questionAnalysis["How effectively does VDart act as a strategic hiring partner rather than just a service provider?"].responses[record.partnership]++;
      }
      if (record.communication && record.communication !== 'Not Answered') {
        questionAnalysis["How would you rate the responsiveness and communication of your VDart client Partner?"].responses[record.communication]++;
      }
      if (record.npsScore !== null && record.npsScore !== undefined) {
        questionAnalysis["How likely is it that you would recommend VDart to a friend or colleague?"].responses[record.npsScore.toString()]++;
      }
    });

    // Calculate averages and NPS
    Object.keys(questionAnalysis).forEach(question => {
      const data = questionAnalysis[question];
      let totalScore = 0;
      let totalResponses = 0;

      if (question === "How likely is it that you would recommend VDart to a friend or colleague?") {
        Object.entries(data.responses).forEach(([score, count]) => {
          totalScore += parseInt(score) * count;
          totalResponses += count;
        });
        
        const promoters = (data.responses["10"] || 0) + (data.responses["9"] || 0);
        const passives = (data.responses["8"] || 0) + (data.responses["7"] || 0);
        const detractors = (data.responses["6"] || 0) + (data.responses["5"] || 0) + (data.responses["4"] || 0) + (data.responses["3"] || 0) + (data.responses["2"] || 0) + (data.responses["1"] || 0) + (data.responses["0"] || 0);
        
        data.promoters = promoters;
        data.passives = passives;
        data.detractors = detractors;
        data.npsScore = totalResponses > 0 ? ((promoters - detractors) / totalResponses) * 100 : 0;
      } else {
        Object.entries(data.responses).forEach(([rating, count]) => {
          if (rating !== "NA") {
            const score = parseInt(rating.split(' ')[0]);
            totalScore += score * count;
            totalResponses += count;
          }
        });
      }

      data.avgScore = totalResponses > 0 ? totalScore / totalResponses : 0;
      data.totalResponses = totalResponses;
    });

    return questionAnalysis;
  };

  const getQuestionResponses = (question, rating) => {
    const currentData = getFilteredData();
    const surveyResponded = currentData.data.filter(r => r.Status === 'Survey Responded');

    if (question === "How likely is it that you would recommend VDart to a friend or colleague?") {
      if (rating === 'promoters') {
        return surveyResponded.filter(r => r.npsScore >= 9);
      } else if (rating === 'passives') {
        return surveyResponded.filter(r => r.npsScore >= 7 && r.npsScore <= 8);
      } else if (rating === 'detractors') {
        return surveyResponded.filter(r => r.npsScore <= 6);
      } else {
        return surveyResponded.filter(r => r.npsScore === parseInt(rating));
      }
    }

    const questionKey = {
      "How well does VDart understand your staffing requirements and expectations?": "understanding",
      "How would you rate the overall quality of candidates VDart has provided?": "quality",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "speed",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "partnership",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "communication"
    }[question];

    return surveyResponded.filter(r => r[questionKey] === rating);
  };

  const styles = {
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f8fafc 0%, #e0f2fe 50%, #e8eaf6 100%)',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif'
    },
    header: {
      backgroundColor: '#ffffff',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      borderBottom: '1px solid #e5e7eb',
      padding: '32px 24px'
    },
    headerContent: {
      maxWidth: '1280px',
      margin: '0 auto',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    title: {
      fontSize: '36px',
      fontWeight: '800',
      background: 'linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      marginBottom: '8px'
    },
    subtitle: {
      fontSize: '16px',
      color: '#6b7280',
      textAlign:'center'
    },
    logo: {
      width: '120px',
      height: 'auto'
    },
    mainContent: {
      maxWidth: '1280px',
      margin: '0 auto',
      padding: '32px 24px'
    },
    controlsCard: {
      backgroundColor: '#ffffff',
      borderRadius: '16px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      padding: '24px',
      marginBottom: '32px',
      border: '1px solid #e5e7eb'
    },
    controlsHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px'
    },
    controlsTitle: {
      display: 'flex',
      alignItems: 'center'
    },
    iconContainer: {
      backgroundColor: '#e0e7ff',
      borderRadius: '50%',
      padding: '8px',
      marginRight: '12px'
    },
    sectionTitle: {
      fontSize: '20px',
      fontWeight: '700',
      color: '#1f2937',
      marginBottom: '4px'
    },
    filterGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '16px'
    },
    filterGroup: {
      display: 'flex',
      flexDirection: 'column'
      ,
      alignItems: 'center',
    },
    filterLabel: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#374151',
      marginBottom: '8px'
    },
    filterSelect: {
      width: '100%',
      border: '1px solid #d1d5db',
      borderRadius: '8px',
      padding: '10px 12px',
      fontSize: '14px',
      backgroundColor: '#ffffff',
      outline: 'none',
      transition: 'border-color 0.2s ease',
      cursor: 'pointer'
    },
    kpiGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '20px',
      marginBottom: '32px'
    },
    kpiCard: {
      backgroundColor: '#ffffff',
      borderRadius: '16px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      padding: '20px',
      border: '1px solid #e5e7eb',
      transition: 'all 0.2s ease',
      cursor: 'pointer'
    },
    kpiHeader: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '12px'
    },
    kpiValue: {
      fontSize: '28px',
      fontWeight: '800',
      color: '#1f2937',
      marginBottom: '4px'
    },
    kpiSubtitle: {
      fontSize: '14px',
      color: '#6b7280'
    },
    kpiClickHint: {
      fontSize: '12px',
      color: '#2563eb',
      marginTop: '4px',
      fontWeight: '500'
    },
    viewButtons: {
      display: 'flex',
      gap: '12px'
    },
    viewButton: {
      padding: '8px 16px',
      borderRadius: '8px',
      fontWeight: '600',
      fontSize: '14px',
      transition: 'all 0.2s ease',
      border: 'none',
      cursor: 'pointer'
    },
    viewButtonActive: {
      backgroundColor: '#2563eb',
      color: 'white'
    },
    viewButtonInactive: {
      backgroundColor: '#f3f4f6',
      color: '#374151'
    },
    sectionCard: {
      backgroundColor: '#ffffff',
      borderRadius: '16px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      padding: '24px',
      marginBottom: '24px',
      border: '1px solid #e5e7eb'
    },
    sectionHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '24px'
    },
    twoColumnLayout: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '24px',
      marginBottom: '32px'
    },
    threeColumnLayout: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gap: '24px',
      marginBottom: '32px'
    },
    pieChartCard: {
      backgroundColor: '#ffffff',
      borderRadius: '16px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      padding: '24px',
      border: '1px solid #e5e7eb'
    },
    pieChartTitle: {
      fontSize: '18px',
      fontWeight: '700',
      color: '#1f2937',
      marginBottom: '16px',
      textAlign: 'center'
    },
    pieChartLegend: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: '12px',
      marginTop: '16px'
    },
    legendItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px'
    },
    legendColor: {
      width: '12px',
      height: '12px',
      borderRadius: '50%'
    },
    legendText: {
      fontSize: '14px',
      color: '#374151'
    },
    modal: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '16px'
    },
    modalContent: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)',
      maxWidth: '1000px',
      width: '100%',
      maxHeight: '80vh',
      overflowY: 'auto'
    },
    modalHeader: {
      padding: '20px',
      borderBottom: '1px solid #e5e7eb',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    modalTitle: {
      fontSize: '20px',
      fontWeight: '700',
      color: '#1f2937'
    },
    closeButton: {
      padding: '8px',
      backgroundColor: 'transparent',
      border: 'none',
      borderRadius: '50%',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    },
    modalBody: {
      padding: '20px'
    },
    responseGrid: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    },
    responseCard: {
      background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
      borderRadius: '12px',
      padding: '16px',
      border: '1px solid #e2e8f0'
    },
    responseHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '12px'
    },
    responseUserInfo: {
      display: 'flex',
      alignItems: 'center'
    },
    responseAvatar: {
      backgroundColor: '#e0e7ff',
      borderRadius: '50%',
      padding: '8px',
      marginRight: '12px'
    },
    responseUserName: {
      fontSize: '16px',
      fontWeight: '700',
      color: '#1f2937'
    },
    responseUserClient: {
      fontSize: '12px',
      color: '#6b7280'
    },
    responseStatus: {
      backgroundColor: '#2563eb',
      color: 'white',
      padding: '4px 8px',
      borderRadius: '12px',
      fontSize: '11px',
      fontWeight: '600'
    },
    responseDetails: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
      gap: '8px'
    },
    responseDetail: {
      display: 'flex',
      alignItems: 'center'
    },
    responseDetailIcon: {
      width: '14px',
      height: '14px',
      color: '#9ca3af',
      marginRight: '6px'
    },
    responseDetailText: {
      fontSize: '12px',
      color: '#6b7280'
    },
    responseRatings: {
      marginTop: '12px',
      paddingTop: '12px',
      borderTop: '1px solid #e5e7eb'
    },
    ratingsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(80px, 1fr))',
      gap: '8px'
    },
    ratingItem: {
      textAlign: 'center'
    },
    ratingLabel: {
      fontSize: '10px',
      fontWeight: '600',
      color: '#374151'
    },
    ratingValue: {
      fontSize: '12px',
      fontWeight: '700'
    },
    summary: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px',
      backgroundColor: '#f8fafc',
      borderRadius: '12px',
      margin: '20px 0',
      border: '2px solid #2563eb'
    },
    summaryText: {
      fontSize: '18px',
      fontWeight: '700',
      color: '#2563eb'
    },
    buGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: '20px'
    },
    buCard: {
      background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
      borderRadius: '12px',
      padding: '20px',
      border: '1px solid #e2e8f0',
      transition: 'all 0.2s ease'
    },
    buHeader: {
      textAlign: 'center',
      marginBottom: '16px'
    },
    buTitle: {
      fontSize: '18px',
      fontWeight: '700',
      color: '#1f2937',
      marginBottom: '8px'
    },
    buResponseRate: {
      fontSize: '32px',
      fontWeight: '800',
      color: '#4338ca',
      marginBottom: '4px'
    },
    buMetrics: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },
    buMetricRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    buMetricLabel: {
      fontSize: '14px',
      color: '#6b7280',
      fontWeight: '500'
    },
    buMetricValue: {
      fontSize: '16px',
      fontWeight: '700'
    },
    progressBar: {
      width: '100%',
      height: '8px',
      backgroundColor: '#e5e7eb',
      borderRadius: '4px',
      overflow: 'hidden',
      marginTop: '12px'
    },
    progressFill: {
      height: '100%',
      transition: 'width 0.5s ease',
      borderRadius: '4px'
    },
    functionCard: {
      background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
      borderRadius: '12px',
      padding: '16px',
      border: '1px solid #bae6fd',
      marginBottom: '12px'
    },
    functionHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '8px'
    },
    functionTitle: {
      fontSize: '14px',
      fontWeight: '700',
      color: '#0c4a6e'
    },
    functionResponseRate: {
      fontSize: '14px',
      fontWeight: '800',
      color: '#0369a1'
    },
    functionMetrics: {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: '12px',
      color: '#64748b'
    },
    npsCard: {
      background: 'linear-gradient(135deg, #eff6ff 0%, #e0f2fe 100%)',
      borderRadius: '16px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      padding: '24px',
      marginBottom: '24px',
      border: '1px solid #bfdbfe'
    },
    npsHeader: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '20px'
    },
    npsTitle: {
      fontSize: '24px',
      fontWeight: '700',
      color: '#1f2937',
      marginBottom: '4px'
    },
    npsGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '24px'
    },
    npsScoreSection: {
      textAlign: 'center',
      marginBottom: '20px'
    },
    npsScore: {
      fontSize: '64px',
      fontWeight: '800',
      color: '#2563eb',
      marginBottom: '8px'
    },
    npsDescription: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#374151',
      marginBottom: '4px'
    },
    npsScaleContainer: {
      background: 'linear-gradient(90deg, #fecaca 0%, #fef3c7 50%, #bbf7d0 100%)',
      borderRadius: '12px',
      padding: '12px'
    },
    npsScaleGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(11, 1fr)',
      gap: '4px',
      marginBottom: '8px'
    },
    npsScaleItem: {
      height: '40px',
      borderRadius: '6px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '11px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      color: 'white'
    },
    npsCategories: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    },
    npsCategoryCard: {
      borderRadius: '12px',
      padding: '16px',
      color: 'white',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    npsCategoryTitle: {
      fontSize: '16px',
      fontWeight: '700',
      marginBottom: '2px'
    },
    npsCategorySubtitle: {
      fontSize: '12px',
      opacity: 0.9
    },
    npsCategoryValue: {
      fontSize: '32px',
      fontWeight: '800'
    },
    questionGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '20px'
    },
    questionCard: {
      background: 'linear-gradient(135deg, #eff6ff 0%, #e0f2fe 100%)',
      borderRadius: '12px',
      padding: '20px',
      border: '1px solid #bfdbfe'
    },
    questionTitle: {
      fontSize: '16px',
      fontWeight: '700',
      color: '#1e40af',
      marginBottom: '8px',
      lineHeight: '1.4'
    },
    questionSubtitle: {
      fontSize: '12px',
      color: '#6b7280',
      marginBottom: '12px',
      fontStyle: 'italic'
    },
    questionScore: {
      textAlign: 'center',
      marginBottom: '16px'
    },
    questionScoreValue: {
      fontSize: '36px',
      fontWeight: '800',
      color: '#2563eb',
      marginBottom: '4px'
    },
    questionScoreLabel: {
      fontSize: '12px',
      color: '#6b7280'
    },
    questionResponses: {
      display: 'flex',
      flexDirection: 'column',
      gap: '6px'
    },
    questionResponse: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    questionResponseLabel: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '12px',
      color: '#374151',
      fontWeight: '500'
    },
    questionResponseValue: {
      fontSize: '14px',
      fontWeight: '700',
      color: '#2563eb',
      cursor: 'pointer',
      textDecoration: 'underline'
    },
    starContainer: {
      display: 'flex',
      marginLeft: '6px'
    },
    star: {
      width: '10px',
      height: '10px',
      marginRight: '1px'
    },
    clientGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '20px'
    },
    clientCard: {
      background: 'linear-gradient(135deg, #f0fdf4 0%, #f7fee7 100%)',
      borderRadius: '12px',
      padding: '20px',
      border: '1px solid #bbf7d0',
      transition: 'all 0.2s ease'
    },
    clientTitle: {
      fontSize: '16px',
      fontWeight: '700',
      color: '#166534',
      marginBottom: '12px'
    },
    clientStats: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '16px'
    },
    clientStat: {
      textAlign: 'center'
    },
    clientStatValue: {
      fontSize: '20px',
      fontWeight: '800',
      marginBottom: '4px'
    },
    clientStatLabel: {
      fontSize: '11px',
      color: '#6b7280',
      fontWeight: '500'
    },
    functionButtons: {
      display: 'flex',
      gap: '12px',
      marginBottom: '20px'
    },
    functionButton: {
      padding: '8px 16px',
      borderRadius: '8px',
      fontWeight: '600',
      fontSize: '14px',
      transition: 'all 0.2s ease',
      border: 'none',
      cursor: 'pointer'
    },
    functionButtonActive: {
      backgroundColor: '#16a34a',
      color: 'white'
    },
    functionButtonInactive: {
      backgroundColor: '#f3f4f6',
      color: '#374151'
    },
    detailedAnalysisCard: {
      backgroundColor: '#ffffff',
      borderRadius: '16px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      padding: '24px',
      marginBottom: '24px',
      border: '1px solid #e5e7eb'
    },
    accordionItem: {
      border: '1px solid #e5e7eb',
      borderRadius: '8px',
      marginBottom: '12px',
      overflow: 'hidden'
    },
    accordionHeader: {
      padding: '16px',
      backgroundColor: '#f8fafc',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      transition: 'background-color 0.2s ease'
    },
    accordionHeaderActive: {
      backgroundColor: '#e0f2fe'
    },
    accordionTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#1f2937'
    },
    accordionContent: {
      padding: '16px',
      backgroundColor: '#ffffff',
      borderTop: '1px solid #e5e7eb'
    },
    responseTable: {
      width: '100%',
      fontSize: '12px',
      borderCollapse: 'collapse'
    },
    responseTableHeader: {
      backgroundColor: '#f3f4f6',
      fontWeight: '600',
      color: '#374151'
    },
    responseTableCell: {
      padding: '8px',
      borderBottom: '1px solid #e5e7eb'
    },
    responseTableRow: {
      transition: 'background-color 0.2s ease'
    },
    responseTableRowHover: {
      backgroundColor: '#f8fafc'
    }
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div style={{
          backgroundColor: '#ffffff',
          padding: '12px',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <p style={{ fontWeight: '600', color: '#1f2937', marginBottom: '4px' }}>{`${label}`}</p>
          {payload.map((entry, index) => (
            <p key={index} style={{ fontSize: '14px', color: entry.color, margin: '2px 0' }}>
              {`${entry.name}: ${entry.value}`}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  const FunctionWiseChart = () => {
    const [chartViewType, setChartViewType] = useState('chart');
    const functionData = getFunctionWiseData();

    const styles = {
    pieChartCard: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      padding: '24px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      marginBottom: '24px'
    },
    sectionHeader: {
      marginBottom: '20px'
    },
    controlsTitle: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px'
    },
    iconContainer: {
      width: '48px',
      height: '48px',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    pieChartTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#1f2937',
      marginBottom: '4px',
      display: 'flex',
      alignItems: 'center'
    },
    viewButton: {
      padding: '8px 16px',
      border: '1px solid #e5e7eb',
      borderRadius: '8px',
      backgroundColor: '#ffffff',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s'
    },
    viewButtonActive: {
      backgroundColor: '#10b981',
      color: '#ffffff',
      borderColor: '#10b981'
    },
    viewButtonInactive: {
      backgroundColor: '#ffffff',
      color: '#6b7280',
      borderColor: '#e5e7eb'
    },
    dataTable: {
      width: '100%',
      borderCollapse: 'collapse',
      marginTop: '20px',
      fontSize: '14px'
    }
  };
    const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div style={{
          backgroundColor: '#ffffff',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          padding: '12px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
        }}>
          <p style={{ fontWeight: '600', marginBottom: '8px', color: '#1f2937' }}>{label}</p>
          {payload.map((entry, index) => (
            <p key={index} style={{ margin: '4px 0', fontSize: '13px' }}>
              <span style={{ color: entry.color }}>●</span> {entry.name}: {entry.value}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };
    
    return (
    <div style={styles.pieChartCard}>
      <div style={styles.sectionHeader}>
        <div style={styles.controlsTitle}>
          <div style={{ ...styles.iconContainer, backgroundColor: '#dcfce7' }}>
            <BarChart3 style={{ width: '20px', height: '20px', color: '#16a34a' }} />
          </div>
          <div>
            <h3 style={styles.pieChartTitle}>
              Function-wise Response Analysis 
              <BarChart3 style={{ width: '16px', height: '16px', color: '#16a34a', marginLeft: '8px', display: 'inline-block' }} />
            </h3>
            <p style={{ fontSize: '14px', color: '#6b7280' }}>Breakdown by role type</p>
          </div>
        </div>
        
        {/* Add toggle buttons */}
        <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
          <button 
            style={{
              ...styles.viewButton,
              ...(chartViewType === 'chart' ? styles.viewButtonActive : styles.viewButtonInactive)
            }}
            onClick={() => setChartViewType('chart')}
          >
            <BarChart3 style={{ width: '16px', height: '16px', marginRight: '8px' }} />
            Chart View
          </button>
          <button 
            style={{
              ...styles.viewButton,
              ...(chartViewType === 'table' ? styles.viewButtonActive : styles.viewButtonInactive)
            }}
            onClick={() => setChartViewType('table')}
          >
            <FileText style={{ width: '16px', height: '16px', marginRight: '8px' }} />
            Table View
          </button>
        </div>
      </div>
      
      {/* Conditionally render chart or table */}
      {chartViewType === 'chart' ? (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={functionData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="name" tick={{ fill: '#374151', fontSize: 12 }} />
            <YAxis tick={{ fill: '#374151', fontSize: 12 }} />
            <Tooltip content={<CustomTooltip />} />
            <Bar dataKey="completed" fill="#10b981" radius={[4, 4, 0, 0]} name="Completed" />
            <Bar dataKey="Non-Responders" fill="#f59e0b" radius={[4, 4, 0, 0]} name="Non-Responders" />
            <Bar dataKey="Technical Issues" fill="#ec4899" radius={[4, 4, 0, 0]} name="Technical Issues" />
            <Legend 
              wrapperStyle={{ paddingTop: '20px' }}
              iconType="rect"
              formatter={(value) => <span style={{ color: '#374151', fontSize: '12px' }}>{value}</span>}
            />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <table style={styles.dataTable}>
          <thead>
            <tr style={{ backgroundColor: '#f9fafb' }}>
              <th style={{ 
                padding: '12px', 
                textAlign: 'left', 
                fontWeight: '600',
                color: '#374151',
                borderBottom: '2px solid #e5e7eb'
              }}>Function</th>
              <th style={{ 
                padding: '12px', 
                textAlign: 'center', 
                fontWeight: '600',
                color: '#374151',
                borderBottom: '2px solid #e5e7eb'
              }}>Completed</th>
              <th style={{ 
                padding: '12px', 
                textAlign: 'center', 
                fontWeight: '600',
                color: '#374151',
                borderBottom: '2px solid #e5e7eb'
              }}>Non-Responders</th>
              <th style={{ 
                padding: '12px', 
                textAlign: 'center', 
                fontWeight: '600',
                color: '#374151',
                borderBottom: '2px solid #e5e7eb'
              }}>Technical Issues</th>
            </tr>
          </thead>
          <tbody>
            {functionData.map((row, idx) => (
              <tr key={idx} style={{ borderBottom: '1px solid #e5e7eb' }}>
                <td style={{ padding: '12px', fontWeight: '500', color: '#1f2937' }}>{row.name}</td>
                <td style={{ padding: '12px', textAlign: 'center', color: '#10b981', fontWeight: '600' }}>{row.completed}</td>
                <td style={{ padding: '12px', textAlign: 'center', color: '#f59e0b', fontWeight: '600' }}>{row['Non-Responders']}</td>
                <td style={{ padding: '12px', textAlign: 'center', color: '#ec4899', fontWeight: '600' }}>{row['Technical Issues']}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

  const ResponseTypePieChart = ({ data }) => {
    const COLORS = ['#10b981', '#f59e0b', '#ec4899'];
    
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
      const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
      const x = cx + radius * Math.cos(-midAngle * Math.PI / 180);
      const y = cy + radius * Math.sin(-midAngle * Math.PI / 180);
      
      return percent > 0.05 ? (
        <text 
          x={x} 
          y={y} 
          fill="white" 
          textAnchor={x > cx ? 'start' : 'end'} 
          dominantBaseline="central"
          fontSize="14"
          fontWeight="600"
        >
          {`${(percent * 100).toFixed(0)}%`}
        </text>
      ) : null;
    };

    return (
      <div style={styles.pieChartCard}>
        <div style={styles.sectionHeader}>
          <div style={styles.controlsTitle}>
            <div style={{ ...styles.iconContainer, backgroundColor: '#fce7f3' }}>
              <PieChartIcon style={{ width: '20px', height: '20px', color: '#ec4899' }} />
            </div>
            <div>
              <h3 style={styles.pieChartTitle}>Response Distribution 🎯</h3>
              <p style={{ fontSize: '14px', color: '#6b7280' }}>Survey response breakdown</p>
            </div>
          </div>
        </div>
        
        <ResponsiveContainer width="100%" height={250}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={renderCustomizedLabel}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
        
        <div style={styles.pieChartLegend}>
          {data.map((item, index) => (
            <div key={index} style={styles.legendItem}>
              <div style={{ ...styles.legendColor, backgroundColor: item.color }}></div>
              <span style={styles.legendText}>{item.name}: {item.value}</span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const ClientWiseChart = ({ data }) => {
    const pieData = [
      { name: 'Completed', value: data.completed, color: '#10b981' },
      { name: 'Non-Responders', value: data.nonResponders, color: '#f59e0b' },
      { name: 'Technical Issues', value: data.technicalIssues, color: '#ec4899' }
    ].filter(item => item.value > 0);

    return (
      <div style={{ height: '150px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={pieData}
              cx="50%"
              cy="50%"
              outerRadius={50}
              fill="#8884d8"
              dataKey="value"
            >
              {pieData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>
    );
  };

  const KPICard = ({ title, value, icon: Icon, color = "blue", subtitle = "", onClick = null, detailType = null }) => {
    const [isHovered, setIsHovered] = useState(false);
    
    const colorMap = {
      blue: { bg: '#dbeafe', icon: '#2563eb', border: '#3b82f6' },
      green: { bg: '#dcfce7', icon: '#16a34a', border: '#22c55e' },
      orange: { bg: '#fed7aa', icon: '#ea580c', border: '#f97316' },
      red: { bg: '#fecaca', icon: '#dc2626', border: '#ef4444' },
      purple: { bg: '#e9d5ff', icon: '#7c3aed', border: '#8b5cf6' },
      pink: { bg: '#fce7f3', icon: '#db2777', border: '#ec4899' }
    };

    const colors = colorMap[color];
    
    return (
      <div 
        style={{
          ...styles.kpiCard,
          borderLeft: `4px solid ${colors.border}`,
          transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
          boxShadow: isHovered ? '0 8px 16px rgba(0, 0, 0, 0.15)' : '0 4px 6px rgba(0, 0, 0, 0.1)',
          ...(onClick ? { cursor: 'pointer' } : {})
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={onClick ? () => {
          setSelectedDetailType(detailType);
          setShowDetailModal(true);
        } : undefined}
      >
        <div style={styles.kpiHeader}>
          <div style={{ ...styles.iconContainer, backgroundColor: colors.bg }}>
            <Icon style={{ width: '20px', height: '20px', color: colors.icon }} />
          </div>
          <p style={{ fontSize: '12px', fontWeight: '600', color: '#374151', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
            {title}
          </p>
        </div>
        <p style={styles.kpiValue}>{value}</p>
        {subtitle && <p style={styles.kpiSubtitle}>{subtitle}</p>}
        
        {onClick && (
          <p style={styles.kpiClickHint}>
            Click to view details 
            <ChevronRight style={{ width: '12px', height: '12px', marginLeft: '4px', display: 'inline-block' }} />
          </p>
        )}
      </div>
    );
  };

  const NPSCard = ({ data }) => (
    <div style={styles.npsCard}>
      <div style={styles.npsHeader}>
        <div style={{ ...styles.iconContainer, backgroundColor: '#bfdbfe' }}>
          <Award style={{ width: '24px', height: '24px', color: '#2563eb' }} />
        </div>
        <div>
          <h3 style={styles.npsTitle}>
            Net Promoter Score 
            <Award style={{ width: '20px', height: '20px', color: '#2563eb', marginLeft: '8px', display: 'inline-block' }} />
          </h3>
          <p style={{ color: '#6b7280' }}>How likely are you to recommend VDart?</p>
        </div>
      </div>
      
      <div style={styles.npsGrid}>
        <div>
          <div style={styles.npsScoreSection}>
            <div style={styles.npsScore}>{data.npsScore?.toFixed(1) || 0}</div>
            <div style={styles.npsDescription}>
              {(data.npsScore || 0) >= 50 ? (
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  Excellent <Star style={{ width: '16px', height: '16px', marginLeft: '4px', fill: '#fbbf24', color: '#fbbf24' }} />
                </span>
              ) : (data.npsScore || 0) >= 0 ? (
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  Good <TrendingUp style={{ width: '16px', height: '16px', marginLeft: '4px', color: '#22c55e' }} />
                </span>
              ) : (
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  Needs Improvement <TrendingDown style={{ width: '16px', height: '16px', marginLeft: '4px', color: '#ef4444' }} />
                </span>
              )}
            </div>
            <div style={{ color: '#6b7280' }}>Based on {data.totalResponses || 0} responses</div>
          </div>
          
          <div style={styles.npsScaleContainer}>
            <div style={styles.npsScaleGrid}>
              {[0,1,2,3,4,5,6,7,8,9,10].map(score => (
                <div 
                  key={score}
                  style={{
                    ...styles.npsScaleItem,
                    backgroundColor: score <= 6 ? '#ef4444' : score <= 8 ? '#eab308' : '#22c55e'
                  }}
                  onClick={() => {
                    setSelectedSurveyQuestion("How likely is it that you would recommend VDart to a friend or colleague?");
                    setSelectedRating(score.toString());
                    setShowDetailModal(true);
                  }}
                  onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                  onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                >
                  <div>{score}</div>
                  <div style={{ fontSize: '9px' }}>({data.responses?.[score.toString()] || 0})</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <div style={styles.npsCategories}>
          <div 
            style={{
              ...styles.npsCategoryCard,
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
            }}
            onClick={() => {
              setSelectedSurveyQuestion("How likely is it that you would recommend VDart to a friend or colleague?");
              setSelectedRating('promoters');
              setShowDetailModal(true);
            }}
          >
            <div>
              <div style={styles.npsCategoryTitle}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  Promoters <Star style={{ width: '16px', height: '16px', marginLeft: '4px', fill: 'white' }} />
                </span>
              </div>
              <div style={styles.npsCategorySubtitle}>Score 9-10</div>
            </div>
            <div style={styles.npsCategoryValue}>{data.promoters || 0}</div>
          </div>
          
          <div 
            style={{
              ...styles.npsCategoryCard,
              background: 'linear-gradient(135deg, #eab308 0%, #ca8a04 100%)'
            }}
            onClick={() => {
              setSelectedSurveyQuestion("How likely is it that you would recommend VDart to a friend or colleague?");
              setSelectedRating('passives');
              setShowDetailModal(true);
            }}
          >
            <div>
              <div style={styles.npsCategoryTitle}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  Passives <Activity style={{ width: '16px', height: '16px', marginLeft: '4px' }} />
                </span>
              </div>
              <div style={styles.npsCategorySubtitle}>Score 7-8</div>
            </div>
            <div style={styles.npsCategoryValue}>{data.passives || 0}</div>
          </div>
          
          <div 
            style={{
              ...styles.npsCategoryCard,
              background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'
            }}
            onClick={() => {
              setSelectedSurveyQuestion("How likely is it that you would recommend VDart to a friend or colleague?");
              setSelectedRating('detractors');
              setShowDetailModal(true);
            }}
          >
            <div>
              <div style={styles.npsCategoryTitle}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  Detractors <TrendingDown style={{ width: '16px', height: '16px', marginLeft: '4px' }} />
                </span>
              </div>
              <div style={styles.npsCategorySubtitle}>Score 0-6</div>
            </div>
            <div style={styles.npsCategoryValue}>{data.detractors || 0}</div>
          </div>
        </div>
      </div>
    </div>
  );

const DetailModal = ({ isOpen, onClose, detailType, question, rating }) => {
  if (!isOpen) return null;

  let responses = [];
  let title = '';

  if (detailType) {
    responses = getDetailedResponses(detailType);
    title = `${detailType} (${responses.length} records)`;
  } else if (question && rating) {
    responses = getQuestionResponses(question, rating);
    if (question === "How likely is it that you would recommend VDart to a friend or colleague?") {
      if (rating === 'promoters') title = `Promoters (Score 9-10) - ${responses.length} records`;
      else if (rating === 'passives') title = `Passives (Score 7-8) - ${responses.length} records`;
      else if (rating === 'detractors') title = `Detractors (Score 0-6) - ${responses.length} records`;
      else title = `Score ${rating} Responses - ${responses.length} records`;
    } else {
      title = `${rating} Responses - ${responses.length} records`;
    }
  }

  return (
    <div style={styles.modal}>
      <div style={styles.modalContent}>
        <div style={styles.modalHeader}>
          <h2 style={styles.modalTitle}>{title}</h2>
          <button 
            style={styles.closeButton}
            onClick={onClose}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
          </button>
        </div>
        {question && <p style={{ padding: '0 20px', color: '#6b7280', fontSize: '14px' }}>{question}</p>}
        
        <div style={styles.modalBody}>
          <div style={styles.responseGrid}>
            {responses.map((response, index) => (
              <div key={index} style={styles.responseCard}>
                <div style={styles.responseHeader}>
                  <div style={styles.responseUserInfo}>
                    <div style={styles.responseAvatar}>
                      <User style={{ width: '20px', height: '20px', color: '#4f46e5' }} />
                    </div>
                    <div>
                      <h3 style={styles.responseUserName}>
                        {response["First Name"]} {response["Last Name"]}
                      </h3>
                      <p style={styles.responseUserClient}>{response.Client}</p>
                    </div>
                  </div>
                  <div style={{
                    ...styles.responseStatus,
                    ...(response.Status === 'Technical issue' && {
                      backgroundColor: '#dc2626',
                      maxWidth: '200px',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    })
                  }}
                  title={response.Status === 'Technical issue' && response.reason ? response.reason : ''}
                  >
                    {response.Status === 'Technical issue' && response.reason ? 
                      response.reason : 
                      response.npsScore ? 
                      `NPS: ${response.npsScore}` : 
                      response.Status}
                  </div>
                </div>
                
                <div style={styles.responseDetails}>
                  <div style={styles.responseDetail}>
                    <Mail style={styles.responseDetailIcon} />
                    <span style={styles.responseDetailText}>{response.Email}</span>
                  </div>
                  <div style={styles.responseDetail}>
                    <Building2 style={styles.responseDetailIcon} />
                    <span style={styles.responseDetailText}>{response.BU} BU</span>
                  </div>
                  <div style={styles.responseDetail}>
                    <Briefcase style={styles.responseDetailIcon} />
                    <span style={styles.responseDetailText}>{response.Function}</span>
                  </div>
                  <div style={styles.responseDetail}>
                    <Star style={styles.responseDetailIcon} />
                    <span style={styles.responseDetailText}>{response.Client}</span>
                  </div>
                </div>

                {response.Status === 'Survey Responded' && (
                  <div style={styles.responseRatings}>
                    <div style={styles.ratingsGrid}>
                      <div style={styles.ratingItem}>
                        <div style={styles.ratingLabel}>Understanding</div>
                        <div style={{ ...styles.ratingValue, color: '#2563eb' }}>{response.understanding || 'N/A'}</div>
                      </div>
                      <div style={styles.ratingItem}>
                        <div style={styles.ratingLabel}>Quality</div>
                        <div style={{ ...styles.ratingValue, color: '#16a34a' }}>{response.quality || 'N/A'}</div>
                      </div>
                      <div style={styles.ratingItem}>
                        <div style={styles.ratingLabel}>Speed</div>
                        <div style={{ ...styles.ratingValue, color: '#eab308' }}>{response.speed || 'N/A'}</div>
                      </div>
                      <div style={styles.ratingItem}>
                        <div style={styles.ratingLabel}>Partnership</div>
                        <div style={{ ...styles.ratingValue, color: '#f97316' }}>{response.partnership || 'N/A'}</div>
                      </div>
                      <div style={styles.ratingItem}>
                        <div style={styles.ratingLabel}>Communication</div>
                        <div style={{ ...styles.ratingValue, color: '#ef4444' }}>{response.communication || 'N/A'}</div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

  const realExcelDataa = [{
      "Status": "Survey Responded",
      "Email": "SaadS1@hexaware.com",
      "First Name": "Saad",
      "Last Name": "Siddiqi",
      "Client": "Hexaware",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "4 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "4 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "Yes",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "3 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 7,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is similar to other vendors we use",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "I am not familiar with VDart's operations"
  },
  {
      "Status": "Survey Responded",
      "Email": "uganesan@altimetrik.com",
      "First Name": "Udhaya",
      "Last Name": "Ganesan",
      "Client": "Altimetrik",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "4 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "5 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 9,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Other (please specify)": "Client partner response with in TAT",
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "bbritto@altimetrik.com",
      "First Name": "Benjamin",
      "Last Name": "Britto",
      "Client": "Altimetrik",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "5 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "5 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 9,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": false,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": true,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": false,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": false,
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "ravi.raja@trianz.com",
      "First Name": "Ravishankaran",
      "Last Name": "Raja",
      "Client": "Trianz",
      "Function": "TAG Lead",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": true,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "4 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "4 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "4 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": true,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": true,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": false,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": false,
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "hemalatha.r@trianz.com",
      "First Name": "Hemalatha",
      "Last Name": "Rajagopalan",
      "Client": "Trianz",
      "Function": "TAG Lead",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "5 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "4 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "rakeshs3@hexaware.com",
      "First Name": "Rakesh",
      "Last Name": "Saini",
      "Client": "Hexaware",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": true,
      "How would you rate the overall quality of candidates VDart has provided?": "5 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "5 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": false,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "kalpanas@hexaware.com",
      "First Name": "Kalpana",
      "Last Name": "Som",
      "Client": "Hexaware",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "4 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "3 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "3 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "3 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "4 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Bi-Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 8,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is our number preferred staffing partner",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "MonikaS6@hexaware.com",
      "First Name": "Monika",
      "Last Name": "Sonawane",
      "Client": "Hexaware",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "4 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "4 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "4 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "4 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 8,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is our number preferred staffing partner",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "lalit.bhardwaj@genpact.com",
      "First Name": "Lalit",
      "Last Name": "Bhardwaj",
      "Client": "Genpact",
      "Function": "Hiring Manager",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "5 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "5 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "4 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 9,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is our number preferred staffing partner",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": false,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": false,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": true,
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "haseeb.ma2@cox.com",
      "First Name": "Haseeb",
      "Last Name": "Ma",
      "Client": "Genpact",
      "Function": "Hiring Manager",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "5 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is our number preferred staffing partner",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "SumitS9@hexaware.com",
      "First Name": "Sumit",
      "Last Name": "Srivastava",
      "Client": "Hexaware",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "3 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "2 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "3 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "2 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "3 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Rarely",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 6,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is similar to other vendors we use",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "rajarshi@persistent.com",
      "First Name": "Rajarshi",
      "Last Name": "",
      "Client": "Persistent",
      "Function": "TAG Lead",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "4 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "3 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "3 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "4 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Bi-Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 7,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is similar to other vendors we use",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": false,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "nitins8@hexaware.com",
      "First Name": "Nitin",
      "Last Name": "Sohal",
      "Client": "Hexaware",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "4 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": true,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "4 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "3 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "4 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Bi-Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 7,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is similar to other vendors we use",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "divya.singh01@tredence.com",
      "First Name": "Divya",
      "Last Name": "Singh",
      "Client": "Tredence",
      "Function": "TAG Lead",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "4 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "5 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "4 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is similar to other vendors we use",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": false,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Other (please specify)": "Service in other countries if possible",
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "GauravkumarR@hexaware.com",
      "First Name": "Gaurav",
      "Last Name": "Kumar",
      "Client": "Hexaware",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "1 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "2 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "2 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "2 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "Yes",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "Not Answered",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Not Answered",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Not Answered",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Not Answered",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "Not Answered",
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Not Answered",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Not Answered"
  },
  {
      "Status": "Survey Responded",
      "Email": "sharmila.m@ust.com",
      "First Name": "Sharmila",
      "Last Name": "M",
      "Client": "UST",
      "Function": "Hiring Manager",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "2 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "2 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "2 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "2 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "Yes",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "Not Answered",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Not Answered",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Not Answered",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Not Answered",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "Not Answered",
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Not Answered",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Not Answered"
  },
  {
      "Status": "Survey Responded",
      "Email": "anuj.jain@tredence.com",
      "First Name": "Anuj",
      "Last Name": "Jain",
      "Client": "Tredence",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "4 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": true,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "3 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "4 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "4 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 7,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": false,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "divya.sn@trianz.com",
      "First Name": "Divya",
      "Last Name": "Sn",
      "Client": "Trianz",
      "Function": "TAG Lead",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": true,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "4 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Monthly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 8,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "Gopinath.S@itcinfotech.com",
      "First Name": "Gopinath",
      "Last Name": "S",
      "Client": "ITC - Infotech",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": true,
      "How would you rate the overall quality of candidates VDart has provided?": "5 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "4 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "4 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 9,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "GajawadaV2@hexaware.com",
      "First Name": "Vishwanath",
      "Last Name": "Gajawada",
      "Client": "Hexaware",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "4 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "3 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 9,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Other (please specify)": "Speed can improve.",
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "harshit.tiwari@tredence.com",
      "First Name": "Harshit",
      "Last Name": "Tiwari",
      "Client": "Tredence",
      "Function": "TAG Lead",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "4 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 9,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "inP@hexaware.com",
      "First Name": "Prasanna",
      "Last Name": "Kumar",
      "Client": "Hexaware",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "5 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "4 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 9,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": false,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": true,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": false,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": false,
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "manishk4@hexaware.com",
      "First Name": "Manish",
      "Last Name": " ",
      "Client": "Hexaware",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": true,
      "How would you rate the overall quality of candidates VDart has provided?": "5 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "5 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 9,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": false,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": true,
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "AniteshS@hexaware.com",
      "First Name": "Anitesh",
      "Last Name": "Singh",
      "Client": "Hexaware",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "5 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "5 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Bi-Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": false,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": true,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": false,
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "ArunPrasad.A@cognizant.com",
      "First Name": "ArunPrasad",
      "Last Name": "Arockiasamy",
      "Client": "CTS",
      "Function": "TAG Lead",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "4 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": true,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": true,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": false,
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "Bhavani.santhanam@apexon.com",
      "First Name": "Bhavani",
      "Last Name": "Bhavani",
      "Client": "Apexon",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "5 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "5 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": false,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": true,
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "Vijaykumar.Sundarraj@ust.com",
      "First Name": "Vijaykumar",
      "Last Name": "Sundarraj",
      "Client": "UST",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": true,
      "How would you rate the overall quality of candidates VDart has provided?": "5 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "5 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": false,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "Vinay.Kumar2@ust.com",
      "First Name": "Vinay",
      "Last Name": "Kumar",
      "Client": "UST",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "4 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "3 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 9,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is our number preferred staffing partner",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "shivj@hexaware.com",
      "First Name": "Shiv",
      "Last Name": "Jain",
      "Client": "Hexaware",
      "Function": "TAG",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "5 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "5 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 9,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is our number preferred staffing partner",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "pradeep_n@persistent.com",
      "First Name": "Pradeep",
      "Last Name": "N",
      "Client": "Persistent",
      "Function": "Hiring Manager",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "5 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "5 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is our number preferred staffing partner",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": false,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": true,
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "karthik.deenadayalu@nexteraenergy.com",
      "First Name": "Karthik",
      "Last Name": "Deenadayalu",
      "Client": "NextEra Energy",
      "Function": "Hirirng Manager",
      "BU": "Rohit",
      "How well does VDart understand your staffing requirements and expectations?": "4 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": true,
      "How would you rate the overall quality of candidates VDart has provided?": "3 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "3 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "3 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "4 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Monthly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 8,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is similar to other vendors we use",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": false,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": false,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": true,
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "Bablu12.Kumar@nttdata.com",
      "First Name": "Bablu",
      "Last Name": "Kumar",
      "Client": "NTT Data",
      "Function": "Procurement",
      "BU": "Rohit",
      "How well does VDart understand your staffing requirements and expectations?": "NA",
      "How would you rate the overall quality of candidates VDart has provided?": "NA",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "NA",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "NA",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "NA",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "NA",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "NA",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "NA",
      "How likely is it that you would recommend VDart to a friend or colleague?": 4,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is similar to other vendors we use",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "I am not familiar with VDart's operations"
  },
  {
      "Status": "Survey Responded",
      "Email": "Satyendra.Vishwakarma@nttdata.com",
      "First Name": "Satyendra",
      "Last Name": "Vishwakarma",
      "Client": "NTT Data",
      "Function": "Procurement",
      "BU": "Rohit",
      "How well does VDart understand your staffing requirements and expectations?": "NA",
      "How would you rate the overall quality of candidates VDart has provided?": "NA",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "NA",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "NA",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "NA",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "NA",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "NA",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "NA",
      "How likely is it that you would recommend VDart to a friend or colleague?": 8,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": true,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": false,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": false,
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "tstewart@wrkfrcsol.com",
      "First Name": "Taylar",
      "Last Name": "Stewart",
      "Client": "Hitachi",
      "Function": "Procurement",
      "BU": "Rohit",
      "How well does VDart understand your staffing requirements and expectations?": "NA",
      "How would you rate the overall quality of candidates VDart has provided?": "NA",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "NA",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "NA",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "NA",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "NA",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "NA",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "NA",
      "How likely is it that you would recommend VDart to a friend or colleague?": 8,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "mallaram.shashank@ltimindtree.com",
      "First Name": "Mallaram",
      "Last Name": "Shashank",
      "Client": "LTIMindtree",
      "Function": "TAG",
      "BU": "Nambu",
      "How well does VDart understand your staffing requirements and expectations?": "4 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Other (please specify)": "It depends on position to position.",
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "3 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "3 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "Yes",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "4 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 8,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": false,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "vibin.joseph@ltts.com",
      "First Name": "Vibin Joseph",
      "Last Name": "Sagayaraj",
      "Client": "LTTS",
      "Function": "TAG",
      "BU": "Nambu",
      "How well does VDart understand your staffing requirements and expectations?": "4 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "3 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "3 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "4 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 9,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": false,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": true,
      "Please indicate which additional services you are interested in exploring with VDart? | Other (please specify)": "",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "mandoz.samy@ltts.com",
      "First Name": "Mandoz Anthony",
      "Last Name": "SAMY",
      "Client": "LTTS",
      "Function": "TAG",
      "BU": "Nambu",
      "How well does VDart understand your staffing requirements and expectations?": "4 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "2 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "3 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 7,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "mandhagolla.chakradhar@ltimindtree.com",
      "First Name": "Mandhagolla",
      "Last Name": "Chakradhar",
      "Client": "LTIMindtree",
      "Function": "TAG",
      "BU": "Nambu",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "5 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "4 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "4 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "4 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 9,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": false,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": true,
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "Rana.Kundan@hcltech.com",
      "First Name": "Rana Kundan",
      "Last Name": "Singh",
      "Client": "HCL(CS)",
      "Function": "TAG",
      "BU": "Sidd",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": true,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "3 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "3 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Occasionally",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 7,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is similar to other vendors we use",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": false,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": true,
      "Are you aware that VDart operates on a global scale, not just in North America?": "I am not familiar with VDart's operations"
  },
  {
      "Status": "Survey Responded",
      "Email": "Ankaraju.Yelisetti@genpact.com",
      "First Name": "Ankaraju",
      "Last Name": "Yelisetti",
      "Client": "Genpact",
      "Function": "Hiring Manager",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "5 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "5 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is our number preferred staffing partner",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "Arunpandian.Palpandi@ust.com",
      "First Name": "Arunpandian",
      "Last Name": "Palpandi",
      "Client": "UST",
      "Function": "TAG Lead",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "2 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "3 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "1 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "2 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "Yes",
      "Please specify in the comment box": "Cost issues\nEffective communication between stakeholders , Candidate during the offer issues",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "3 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Rarely",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "I would like to discuss this further",
      "Please specify in the comment box_1": "Do not shy way from your business partners .\nEvery problem will have solution but it has to communicate to us in the initial stage & effectively not in a stage where it becomes complex & difficult for handle .\n\nPlease tell the team ask for help is sign of strength not a weakness",
      "How likely is it that you would recommend VDart to a friend or colleague?": 6,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is similar to other vendors we use",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": false,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": true,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": true,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": true,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": false,
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "Arathi.Nandakumar@itcinfotech.com",
      "First Name": "Arathi",
      "Last Name": "Nandakumar",
      "Client": "ITC - Infotech",
      "Function": "TAG Lead",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "5 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "5 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Other (please specify)": "Attention that we receive from overall VDART team. They are always there to step in for critical positions.",
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "yes, would like to see you all start Europe operations to support us there"
  },
  {
      "Status": "Survey Responded",
      "Email": "Gaurav.singhnegi@nttdata.com",
      "First Name": "Gaurav Singh",
      "Last Name": "Negi",
      "Client": "NTT Data",
      "Function": "Procurement",
      "BU": "Rohit",
      "How well does VDart understand your staffing requirements and expectations?": "NA",
      "How would you rate the overall quality of candidates VDart has provided?": "NA",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "NA",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "NA",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "NA",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "NA",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "NA",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "NA",
      "How likely is it that you would recommend VDart to a friend or colleague?": 8,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is similar to other vendors we use",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "shanthi.bysani@accenture.com",
      "First Name": "Shanthi",
      "Last Name": "Bysani",
      "Client": "Accenture",
      "Function": "Procurement",
      "BU": "Rohit",
      "How well does VDart understand your staffing requirements and expectations?": "NA",
      "How would you rate the overall quality of candidates VDart has provided?": "NA",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "NA",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "NA",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "NA",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "NA",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "NA",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "NA",
      "How likely is it that you would recommend VDart to a friend or colleague?": 9,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "Daniel.Crane@nttdata.com",
      "First Name": "Daniel",
      "Last Name": "Crane",
      "Client": "NTT Data",
      "Function": "Procurement",
      "BU": "Rohit",
      "How well does VDart understand your staffing requirements and expectations?": "NA",
      "How would you rate the overall quality of candidates VDart has provided?": "NA",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "NA",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "NA",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "NA",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "NA",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "NA",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "NA",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Other (please specify)": "Key Account partners are always on hand for escalations or support",
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "chandrashekar.maheshwaram@nttdata.com",
      "First Name": "Chandra Shekar",
      "Last Name": "Maheshwaram",
      "Client": "NTT Data",
      "Function": "Procurement",
      "BU": "Rohit",
      "How well does VDart understand your staffing requirements and expectations?": "NA",
      "How would you rate the overall quality of candidates VDart has provided?": "NA",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "NA",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "NA",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "NA",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "NA",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "NA",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "NA",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is our number preferred staffing partner",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": false,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "antonio.gomez@accenture.com",
      "First Name": "Antonio",
      "Last Name": "Gomez",
      "Client": "Accenture",
      "Function": "TAG Lead",
      "BU": "Rohit",
      "How well does VDart understand your staffing requirements and expectations?": "4 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Other (please specify)": "low volumes",
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "4 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "4 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "4 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Occasionally",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": 9,
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "I had some idea, but was not fully aware"
  },
  {
      "Status": "Survey Responded",
      "Email": "umang.natani@nexteraenergy.com",
      "First Name": "Umang",
      "Last Name": "Natani",
      "Client": "NextEra Energy",
      "Function": "TAG",
      "BU": "Rohit",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "5 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "5 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Bi-Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": true,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": false,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": false,
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "Taylor.Marshall@roberthalf.com",
      "First Name": "Taylor",
      "Last Name": "Marshall",
      "Client": "RHT",
      "Function": "TAG Lead",
      "BU": "Rohit",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": true,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "5 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Bi-Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "damodharan.mohan@apexon.com",
      "First Name": "Damodharan",
      "Last Name": "Mohan",
      "Client": "Apexon",
      "Function": "Procurement",
      "BU": "Oliver",
      "How well does VDart understand your staffing requirements and expectations?": "NA",
      "How would you rate the overall quality of candidates VDart has provided?": "NA",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "NA",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "NA",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "NA",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "NA",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "NA",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "NA",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": false,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "Yes, I'd like to explore more services",
      "Please indicate which additional services you are interested in exploring with VDart? | Services": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Products": false,
      "Please indicate which additional services you are interested in exploring with VDart? | Digital Transformation": false,
      "Please indicate which additional services you are interested in exploring with VDart? | All the above": true,
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "jaime.belton@roberthalf.com",
      "First Name": "Jaime",
      "Last Name": "Belton",
      "Client": "RHT",
      "Function": "TAG Lead",
      "BU": "Rohit",
      "How well does VDart understand your staffing requirements and expectations?": "4 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "How would you rate the overall quality of candidates VDart has provided?": "4 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "4 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "4 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "4 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": false,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "abigail.fox@roberthalf.com",
      "First Name": "Abigail",
      "Last Name": "Fox",
      "Client": "RHT",
      "Function": "TAG Lead",
      "BU": "Rohit",
      "How well does VDart understand your staffing requirements and expectations?": "5 - star",
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Talent Availability": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Hiring Speed": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Cost Control": true,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Candidate Quality": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Industry-Specific Hiring Challenges": false,
      "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed) | Other (please specify)": "Lack of new job reqs to work on, hiring freezes after long process, budget constraints from the client, money negotiations from the client after offers, clients not responding in a timely manner. Clients insisting on interviewing MANY resources to find the most \"perfect\" fit even if they like someone enough and think they would be good",
      "How would you rate the overall quality of candidates VDart has provided?": "5 - star",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "5 - star",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "5 - star",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "No",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "5 - star",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "Weekly",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "Yes, I am satisfied.",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "I believe Vdart is number 1 or 2 vendor for Robert Half",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  },
  {
      "Status": "Survey Responded",
      "Email": "HKelly@hcltech.com",
      "First Name": "Helen",
      "Last Name": "Kelly",
      "Client": "HCL(DB)",
      "Function": "Procurement",
      "BU": "Sidd",
      "How well does VDart understand your staffing requirements and expectations?": "NA",
      "How would you rate the overall quality of candidates VDart has provided?": "NA",
      "How satisfied are you with VDart's speed in delivering candidates for your open roles?": "NA",
      "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": "NA",
      "In the past quarter, have you faced any challenges or difficulties while working with VDart?": "NA",
      "How would you rate the responsiveness and communication of your VDart client Partner?": "NA",
      "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": "NA",
      "Are you satisfied with your current VDart client partner, or would you prefer a change?": "NA",
      "How likely is it that you would recommend VDart to a friend or colleague?": "Extremely likely - 10",
      "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": "VDart is among the top vendors we work with",
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Quality of Candidates": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Speed of Hiring": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Pricing and Value": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Innovation in Recruitment Processes": false,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Scope of Services Offered": true,
      "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed) | Transparency and Communication": true,
      "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": "No, I'm only interested in staffing solutions at this time",
      "Are you aware that VDart operates on a global scale, not just in North America?": "Yes, I am fully aware of VDart's global presence"
  }]

const DetailedAnalysisAccordion = ({ realExcelData }) => {
    const [filters, setFilters] = useState({
        client: '',
        function: '',
        bu: ''
    });
    
    const [expandedQuestion, setExpandedQuestion] = useState(null);
    const [expandedResponse, setExpandedResponse] = useState(null);

    // Add safety check for data
    if (!realExcelDataa || !Array.isArray(realExcelDataa) || realExcelDataa.length === 0) {
        return (
            <div style={{ padding: '20px', textAlign: 'center', color: '#6b7280' }}>
                <p>No survey data available</p>
            </div>
        );
    }

    const uniqueClients = [...new Set(realExcelDataa.map(row => row.Client).filter(Boolean))];
    const uniqueFunctions = [...new Set(realExcelDataa.map(row => row.Function).filter(Boolean))];
    const uniqueBUs = [...new Set(realExcelDataa.map(row => row.BU).filter(Boolean))];

    const filteredExcelData = realExcelDataa.filter(row => {
        const matchClient = !filters.client || (row.Client && row.Client.trim() === filters.client);
        const matchFunction = !filters.function || (row.Function && row.Function.trim() === filters.function);
        const matchBU = !filters.bu || (row.BU && row.BU.trim() === filters.bu);
        return matchClient && matchFunction && matchBU;
    });

    // Get all available columns from the Excel data
    const allAvailableColumns = realExcelDataa.length > 0 ? Object.keys(realExcelDataa[0]) : [];

    const surveyQuestionMapping = {
        // Star-rating questions - using exact column names from data
        "How well does VDart understand your staffing requirements and expectations?": {
            dataKey: "How well does VDart understand your staffing requirements and expectations?",
            type: "star",
            shortTitle: "Understanding Requirements"
        },
        //2
        "What are the top hiring challenges your organization is facing right now?": {
            dataKey: "What are the top hiring challenges your organization is facing right now? (Multiple selections allowed)",
            type: "multi-select",
            shortTitle: "Hiring Challenges",
            options: [
                "Talent Availability",
                "Hiring Speed", 
                "Cost Control",
                "Candidate Quality",
                "Industry-Specific Hiring Challenges",
                "Other (please specify)"
            ]
        },
        //3
        "How would you rate the overall quality of candidates VDart has provided?": {
            dataKey: "How would you rate the overall quality of candidates VDart has provided?", 
            type: "star",
            shortTitle: "Candidate Quality"
        },
        //4
        "How satisfied are you with VDart's speed in delivering candidates for your open roles?": {
            dataKey: "How satisfied are you with VDart's speed in delivering candidates for your open roles?",
            type: "star",
            shortTitle: "Delivery Speed"
        },
        //5
         "How effectively does VDart act as a strategic hiring partner rather than just a service provider?": {
            dataKey: "How effectively does VDart act as a strategic hiring partner rather than just a service provider?",
            type: "star",
            shortTitle: "Strategic Partnership"
        },
        //6
          "In the past quarter, have you faced any challenges or difficulties while working with VDart?": {
            dataKey: "In the past quarter, have you faced any challenges or difficulties while working with VDart?",
            type: "single-choice",
            shortTitle: "Recent Challenges"
        },
        //7
        "How would you rate the responsiveness and communication of your VDart client Partner?": {
            dataKey: "How would you rate the responsiveness and communication of your VDart client Partner?",
            type: "star",
            shortTitle: "Client Partner Communication"
        },
        //8
         "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?": {
            dataKey: "In the past 3 months, how frequently has your VDart client partner proactively checked in with you?",
            type: "single-choice",
            shortTitle: "Partner Check-in Frequency"
        },
        //9
        "Are you satisfied with your current VDart client partner, or would you prefer a change?": {
            dataKey: "Are you satisfied with your current VDart client partner, or would you prefer a change?",
            type: "single-choice",
            shortTitle: "Partner Satisfaction"
        },
        //10
        // NPS question
        "How likely is it that you would recommend VDart to a friend or colleague?": {
            dataKey: "How likely is it that you would recommend VDart to a friend or colleague?",
            type: "nps",
            shortTitle: "Net Promoter Score"
        }
        ,
        //11
        "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?": {
            dataKey: "Among all the staffing vendors you work with, how does VDart rank in terms of service quality and effectiveness?",
            type: "single-choice",
            shortTitle: "Vendor Ranking"
        },
        //12
        // Multi-select questions
        "What key factor influences your willingness to continue working with VDart?": {
            dataKey: "What key factor influences your willingness to continue working with VDart? (Multiple selections allowed)",
            type: "multi-select",
            shortTitle: "Key Influencing Factors",
            options: [
                "Quality of Candidates",
                "Speed of Hiring",
                "Pricing and Value",
                "Innovation in Recruitment Processes",
                "Scope of Services Offered",
                "Transparency and Communication",
                "Other (please specify)"
            ]
        },
        //13
        "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?": {
            dataKey: "Would you be interested in exploring additional services offered by VDart beyond staffing solutions?",
            type: "single-choice",
            shortTitle: "Additional Services Interest"
        },
        //14
        "Please indicate which additional services you are interested in exploring with VDart?": {
            dataKey: "Please indicate which additional services you are interested in exploring with VDart?",
            type: "multi-select",
            shortTitle: "Additional Services Exploration",
            options: [
                "Services",
                "Products",
                "Digital Transformation",
                "All the above",
                "Other (please specify)"
            ]
        },
        //15

        "Are you aware that VDart operates on a global scale, not just in North America?": {
            dataKey: "Are you aware that VDart operates on a global scale, not just in North America?",
            type: "single-choice",
            shortTitle: "Global Operations Awareness"
        },
        
    };

    const getQuestionResponsesDetailed = (question, questionInfo) => {
        // Use filtered data for all calculations
        const respondedData = filteredExcelData.filter(row => row.Status === 'Survey Responded');
        
        if (questionInfo.type === 'star') {
            // Handle star-rating questions with real data
            const responses = respondedData.filter(row => {
                const value = row[questionInfo.dataKey];
                return value && value !== 'Survey Not responded' && value.trim() !== '' && 
                       value !== 'NA' && value !== 'Not Answered';
            });
            
            const responseCounts = {};
            const responseDetails = {};
            
            responses.forEach(row => {
                const response = row[questionInfo.dataKey];
                responseCounts[response] = (responseCounts[response] || 0) + 1;
                
                if (!responseDetails[response]) {
                    responseDetails[response] = [];
                }
                
                responseDetails[response].push({
                    email: row.Email || 'N/A',
                    firstName: row['First Name'] || 'N/A',
                    lastName: row['Last Name'] || 'N/A',
                    client: row.Client || 'N/A',
                    function: row.Function || 'N/A',
                    bu: row.BU || 'N/A'
                });
            });
            
            return {
                totalResponses: responses.length,
                responses: Object.entries(responseCounts)
                    .map(([response, count]) => ({
                        response,
                        count,
                        percentage: responses.length > 0 ? ((count / responses.length) * 100).toFixed(1) : '0',
                        details: responseDetails[response] || []
                    }))
                    .sort((a, b) => {
                        const aNum = parseInt(a.response.split(' ')[0]);
                        const bNum = parseInt(b.response.split(' ')[0]);
                        return bNum - aNum;
                    })
            };
            
        } else if (questionInfo.type === 'nps') {
            // Handle NPS score with real data
            const responses = respondedData.filter(row => {
                const value = row[questionInfo.dataKey];
                return value !== undefined && value !== null && value !== 'Not Answered' && value !== 'NA' && value !== '';
            });
            
            const scoreCounts = {};
            const scoreDetails = {};
            const npsCategories = { promoters: 0, passives: 0, detractors: 0 };
            
            responses.forEach(row => {
                const scoreValue = row[questionInfo.dataKey];
                let score;
                
                // Handle both numeric values and string values like "Extremely likely - 10"
                if (typeof scoreValue === 'number') {
                    score = scoreValue;
                } else if (typeof scoreValue === 'string') {
                    if (scoreValue.includes('10') || scoreValue.includes('Extremely likely')) {
                        score = 10;
                    } else {
                        score = parseInt(scoreValue);
                    }
                }
                
                if (!isNaN(score)) {
                    scoreCounts[score] = (scoreCounts[score] || 0) + 1;
                    
                    if (!scoreDetails[score]) {
                        scoreDetails[score] = [];
                    }
                    
                    scoreDetails[score].push({
                        email: row.Email || 'N/A',
                        firstName: row['First Name'] || 'N/A',
                        lastName: row['Last Name'] || 'N/A',
                        client: row.Client || 'N/A',
                        function: row.Function || 'N/A',
                        bu: row.BU || 'N/A'
                    });
                    
                    // Categorize for NPS
                    if (score >= 9) npsCategories.promoters++;
                    else if (score >= 7) npsCategories.passives++;
                    else npsCategories.detractors++;
                }
            });
            
            const npsScore = responses.length > 0 ? 
                ((npsCategories.promoters / responses.length * 100) - (npsCategories.detractors / responses.length * 100)).toFixed(1) : 0;
            
            return {
                totalResponses: responses.length,
                npsScore,
                npsCategories,
                responses: Object.entries(scoreCounts)
                    .map(([score, count]) => ({
                        response: score,
                        count,
                        percentage: responses.length > 0 ? ((count / responses.length) * 100).toFixed(1) : '0',
                        details: scoreDetails[score] || []
                    }))
                    .sort((a, b) => parseInt(b.response) - parseInt(a.response))
            };
            
        }  else if (questionInfo.type === 'multi-select') {
    // Handle multiple selection questions
    const optionResponses = {};
    const optionDetails = {};
    
    questionInfo.options.forEach(option => {
        optionResponses[option] = 0;
        optionDetails[option] = [];
        
        // Build the exact column name as it appears in the data
        const columnName = `${questionInfo.dataKey} | ${option}`;
        
        respondedData.forEach(row => {
            // Check if the column exists in the row
            if (row.hasOwnProperty(columnName)) {
                const value = row[columnName];
                
                if (option === "Other (please specify)") {
                    // For "Other" option, check if there's text content
                    if (value && typeof value === 'string' && value.trim() !== '' && 
                        value !== 'false' && value !== '0' && value !== 'FALSE') {
                        optionResponses[option]++;
                        optionDetails[option].push({
                            email: row.Email || 'N/A',
                            firstName: row['First Name'] || 'N/A',
                            lastName: row['Last Name'] || 'N/A',
                            client: row.Client || 'N/A',
                            function: row.Function || 'N/A',
                            bu: row.BU || 'N/A',
                            specificValue: value
                        });
                    }
                } else {
                    // For regular options, check for true values
                    if (value === true || value === 1 || value === "1" || 
                        value === "true" || value === "TRUE") {
                        optionResponses[option]++;
                        optionDetails[option].push({
                            email: row.Email || 'N/A',
                            firstName: row['First Name'] || 'N/A',
                            lastName: row['Last Name'] || 'N/A',
                            client: row.Client || 'N/A',
                            function: row.Function || 'N/A',
                            bu: row.BU || 'N/A'
                        });
                    }
                }
            }
        });
    });
    
    const totalRespondents = respondedData.length;
    
    return {
        totalResponses: totalRespondents,
        responses: Object.entries(optionResponses)
            .map(([option, count]) => ({
                response: option,
                count,
                percentage: totalRespondents > 0 ? ((count / totalRespondents) * 100).toFixed(1) : '0',
                details: optionDetails[option] || []
            }))
            .sort((a, b) => b.count - a.count)
    };

            
        } else if (questionInfo.type === 'single-choice') {
            // Handle single choice questions
            const responseCounts = {};
            const responseDetails = {};
            
            respondedData.forEach(row => {
                const value = row[questionInfo.dataKey];
                if (value && 
                    value !== 'Not Answered' && 
                    value !== 'NA' && 
                    value !== 'N/A' &&
                    value !== '' &&
                    value.toString().trim() !== '') {
                    
                    const response = value.toString().trim();
                    responseCounts[response] = (responseCounts[response] || 0) + 1;
                    
                    if (!responseDetails[response]) {
                        responseDetails[response] = [];
                    }
                    
                    responseDetails[response].push({
                        email: row.Email || 'N/A',
                        firstName: row['First Name'] || 'N/A',
                        lastName: row['Last Name'] || 'N/A',
                        client: row.Client || 'N/A',
                        function: row.Function || 'N/A',
                        bu: row.BU || 'N/A'
                    });
                }
            });
            
            const totalResponses = Object.values(responseCounts).reduce((sum, count) => sum + count, 0);
            
            return {
                totalResponses,
                responses: Object.entries(responseCounts)
                    .map(([response, count]) => ({
                        response,
                        count,
                        percentage: totalResponses > 0 ? ((count / totalResponses) * 100).toFixed(1) : '0',
                        details: responseDetails[response] || []
                    }))
                    .sort((a, b) => b.count - a.count)
            };
        }
        
        // For any other type, return empty data
        return {
            totalResponses: 0,
            responses: []
        };
    };

    const renderQuestionVisual = (questionData, questionInfo) => {
        if (!questionData.responses || questionData.responses.length === 0) {
            return (
                <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
                    <p>No responses available for this question</p>
                </div>
            );
        }

        const CustomTooltip = ({ active, payload, label }) => {
            if (active && payload && payload.length) {
                return (
                    <div style={{
                        backgroundColor: '#ffffff',
                        padding: '12px',
                        border: '1px solid #e5e7eb',
                        borderRadius: '8px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                    }}>
                        <p style={{ fontWeight: '600', color: '#1f2937', marginBottom: '4px' }}>{`${label}`}</p>
                        {payload.map((entry, index) => (
                            <p key={index} style={{ fontSize: '14px', color: entry.color, margin: '2px 0' }}>
                                {`${entry.name}: ${entry.value}`}
                            </p>
                        ))}
                    </div>
                );
            }
            return null;
        };

        if (questionInfo.type === 'star') {
            // Bar chart for star ratings
            return (
                <ResponsiveContainer width="100%" height={200}>
                    <BarChart data={questionData.responses}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                        <XAxis dataKey="response" />
                        <YAxis />
                        <Tooltip content={<CustomTooltip />} />
                        <Bar dataKey="count" fill="#3b82f6" radius={[4, 4, 0, 0]} />
                    </BarChart>
                </ResponsiveContainer>
            );
        } else if (questionInfo.type === 'nps') {
            // Special visualization for NPS
            return (
                <div>
                    <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#f3f4f6', borderRadius: '8px' }}>
                        <h6 style={{ fontSize: '16px', fontWeight: '700', marginBottom: '8px' }}>
                            NPS Score: {questionData.npsScore}
                        </h6>
                        <div style={{ display: 'flex', gap: '16px', fontSize: '14px' }}>
                            <span style={{ color: '#059669' }}>
                                Promoters (9-10): {questionData.npsCategories.promoters} ({questionData.totalResponses > 0 ? ((questionData.npsCategories.promoters / questionData.totalResponses) * 100).toFixed(1) : '0'}%)
                            </span>
                            <span style={{ color: '#f59e0b' }}>
                                Passives (7-8): {questionData.npsCategories.passives} ({questionData.totalResponses > 0 ? ((questionData.npsCategories.passives / questionData.totalResponses) * 100).toFixed(1) : '0'}%)
                            </span>
                            <span style={{ color: '#ef4444' }}>
                                Detractors (0-6): {questionData.npsCategories.detractors} ({questionData.totalResponses > 0 ? ((questionData.npsCategories.detractors / questionData.totalResponses) * 100).toFixed(1) : '0'}%)
                            </span>
                        </div>
                    </div>
                    <ResponsiveContainer width="100%" height={200}>
                        <BarChart data={questionData.responses}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                            <XAxis dataKey="response" />
                            <YAxis />
                            <Tooltip content={<CustomTooltip />} />
                            <Bar dataKey="count" fill="#3b82f6" radius={[4, 4, 0, 0]}>
                                {questionData.responses.map((entry, index) => {
                                    const score = parseInt(entry.response);
                                    let fillColor = '#ef4444'; // red for detractors
                                    if (score >= 9) fillColor = '#059669'; // green for promoters
                                    else if (score >= 7) fillColor = '#f59e0b'; // yellow for passives
                                    return <Cell key={`cell-${index}`} fill={fillColor} />;
                                })}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            );
        } else if (questionInfo.type === 'multi-select') {
            // Horizontal bar chart for multiple selections
            return (
                <ResponsiveContainer width="100%" height={Math.max(200, questionData.responses.length * 40)}>
                    <BarChart data={questionData.responses} layout="horizontal">
                        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                        <XAxis type="number" />
                        <YAxis dataKey="response" type="category" width={200} />
                        <Tooltip content={<CustomTooltip />} />
                        <Bar dataKey="count" fill="#8b5cf6" radius={[0, 4, 4, 0]} />
                    </BarChart>
                </ResponsiveContainer>
            );
        } else {
            // Pie chart for single-choice questions
            const pieData = questionData.responses.map((item, index) => ({
                name: item.response,
                value: item.count,
                fill: ['#3b82f6', '#8b5cf6', '#10b981', '#f59e0b', '#ef4444', '#6366f1'][index % 6]
            }));
            
            if (pieData.length === 0) {
                return (
                    <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
                        <p>No data available for visualization</p>
                    </div>
                );
            }
            
            return (
                <ResponsiveContainer width="100%" height={250}>
                    <PieChart>
                        <Pie
                            data={pieData}
                            cx="50%"
                            cy="50%"
                            labelLine={false}
                            label={({ name, percent }) => `${(percent * 100).toFixed(0)}%`}
                            outerRadius={80}
                            fill="#8884d8"
                            dataKey="value"
                        >
                            {pieData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.fill} />
                            ))}
                        </Pie>
                        <Tooltip />
                        <Legend />
                    </PieChart>
                </ResponsiveContainer>
            );
        }
    };

    // Calculate total responded count based on filters
    const totalFilteredResponded = filteredExcelData.filter(row => row.Status === 'Survey Responded').length;

    // Define styles inline for the component
    const styles = {
  detailedAnalysisCard: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '24px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    marginBottom: '24px'
  },
  sectionHeader: {
    marginBottom: '24px',
    borderBottom: '1px solid #e5e7eb',
    paddingBottom: '16px'
  },
  controlsTitle: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%'
  },
  sectionTitle: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#111827',
    margin: '0',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left'
  },
  accordionItem: {
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    marginBottom: '8px',
    overflow: 'hidden'
  },
  accordionHeader: {
    padding: '16px',
    backgroundColor: '#f9fafb',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    textAlign: 'left'
  },
  accordionHeaderActive: {
    backgroundColor: '#ede9fe'
  },
  accordionTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#111827',
    margin: '0',
    textAlign: 'left'
  },
  accordionContent: {
    padding: '16px',
    backgroundColor: '#ffffff',
    borderTop: '1px solid #e5e7eb',
    textAlign: 'left'
  },
  twoColumnLayout: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px',
    alignItems: 'flex-start'
  },
  starContainer: {
    display: 'inline-flex',
    gap: '2px',
    alignItems: 'center'
  },
  star: {
    width: '16px',
    height: '16px'
  },
  responseTable: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px',
    textAlign: 'left'
  },
  responseTableHeader: {
    backgroundColor: '#f9fafb',
    textAlign: 'left'
  },
  responseTableCell: {
    padding: '8px 12px',
    textAlign: 'left',
    borderBottom: '1px solid #e5e7eb'
  },
  responseTableRow: {
    textAlign: 'left'
  }
};

    return (
        <div style={styles.detailedAnalysisCard}>
            <div style={styles.sectionHeader}>
                <div style={styles.controlsTitle}>
                
                    <div>
                        <h3 style={styles.sectionTitle}>
                            Comprehensive Survey Analysis 
                            <Eye style={{ width: '16px', height: '16px', color: '#7c3aed', marginLeft: '8px', display: 'inline-block' }} />
                        </h3>
                        <p style={{ color: '#6b7280' }}>Complete question-by-question breakdown of all survey responses</p>
                        <p style={{ color: '#059669', fontSize: '14px', fontWeight: '600', marginTop: '4px' }}>
                        </p>
                    </div>
                </div>
            </div>

            {/* Filters UI */}
            <div style={{
                display: 'flex',
                gap: '16px',
                marginBottom: '24px',
                flexWrap: 'wrap',
                alignItems: 'left',
                backgroundColor: '#f9fafb',
                padding: '16px',
                borderRadius: '8px',
                border: '1px solid #e5e7eb'
            }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>Client</label>
                    <select
                        value={filters.client}
                        onChange={(e) => setFilters(prev => ({ ...prev, client: e.target.value }))}
                        style={{
                            padding: '8px 12px',
                            fontSize: '14px',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            backgroundColor: '#fff',
                            color: '#111827',
                            minWidth: '180px'
                        }}
                    >
                        <option value="">All Clients</option>
                        {uniqueClients.map((c, i) => <option key={i} value={c}>{c}</option>)}
                    </select>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>Role</label>
                    <select
                        value={filters.function}
                        onChange={(e) => setFilters(prev => ({ ...prev, function: e.target.value }))}
                        style={{
                            padding: '8px 12px',
                            fontSize: '14px',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            backgroundColor: '#fff',
                            color: '#111827',
                            minWidth: '180px'
                        }}
                    >
                        <option value="">All Roles</option>
                        {uniqueFunctions.map((f, i) => <option key={i} value={f}>{f}</option>)}
                    </select>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>BU</label>
                    <select
                        value={filters.bu}
                        onChange={(e) => setFilters(prev => ({ ...prev, bu: e.target.value }))}
                        style={{
                            padding: '8px 12px',
                            fontSize: '14px',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            backgroundColor: '#fff',
                            color: '#111827',
                            minWidth: '180px'
                        }}
                    >
                        <option value="">All BUs</option>
                        {uniqueBUs.map((b, i) => <option key={i} value={b}>{b}</option>)}
                    </select>
                </div>

                {/* Clear Filters Button */}
                {(filters.client || filters.function || filters.bu) && (
                    <button
                        onClick={() => setFilters({ client: '', function: '', bu: '' })}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: '#ef4444',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            marginTop: '20px'
                        }}
                    >
                        Clear Filters
                    </button>
                )}
            </div>

            <div>
                {Object.entries(surveyQuestionMapping).map(([question, questionInfo]) => {
                    const questionData = getQuestionResponsesDetailed(question, questionInfo);
                    const isExpanded = expandedQuestion === question;
                    
                    return (
                        <div key={question} style={styles.accordionItem}>
                            <div 
                                style={{
                                    ...styles.accordionHeader,
                                    ...(isExpanded ? styles.accordionHeaderActive : {})
                                }}
                                onClick={() => setExpandedQuestion(isExpanded ? null : question)}
                            >
                                <div>
                                    <h4 style={styles.accordionTitle}>{questionInfo.shortTitle}</h4>
                                    <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
                                        {question}
                                    </p>
                                    <div style={{ display: 'flex', gap: '16px', marginTop: '4px' }}>
                                        <p style={{ fontSize: '12px', color: '#2563eb', fontWeight: '600' }}>
                                            📊 {questionData.totalResponses} responses
                                        </p>
                                        <p style={{ fontSize: '12px', color: '#7c3aed', fontWeight: '500' }}>
                                            Type: {questionInfo.type}
                                        </p>
                                        {questionInfo.type === 'nps' && (
                                            <p style={{ fontSize: '12px', color: '#059669', fontWeight: '600' }}>
                                                NPS: {questionData.npsScore}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                {isExpanded ? <ChevronUp /> : <ChevronDown />}
                            </div>
                            
                            {isExpanded && (
                                <div style={styles.accordionContent}>
                                    <div style={styles.twoColumnLayout}>
                                        <div>
                                            <h5 style={{ fontSize: '14px', fontWeight: '600', marginBottom: '12px' }}>Response Distribution</h5>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                {questionData.responses.map((item, index) => {
                                                    const responseKey = `${question}-${item.response}`;
                                                    const isResponseExpanded = expandedResponse === responseKey;
                                                    
                                                    return (
                                                        <div key={index} style={styles.accordionItem}>
                                                            <div 
                                                                style={{
                                                                    ...styles.accordionHeader,
                                                                    padding: '12px',
                                                                    ...(isResponseExpanded ? styles.accordionHeaderActive : {})
                                                                }}
                                                                onClick={() => setExpandedResponse(isResponseExpanded ? null : responseKey)}
                                                            >
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    <span style={{ fontSize: '14px', fontWeight: '500' }}>{item.response}</span>
                                                                    {questionInfo.type === 'star' && item.response.includes('star') && (
                                                                        <div style={styles.starContainer}>
                                                                            {[...Array(parseInt(item.response.split(' ')[0]))].map((_, i) => (
                                                                                <Star key={i} style={{ ...styles.star, fill: '#fbbf24', color: '#fbbf24' }} />
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    <span style={{ fontSize: '14px', fontWeight: '700' }}>{item.count}</span>
                                                                    <span style={{ fontSize: '12px', color: '#6b7280' }}>({item.percentage}%)</span>
                                                                    {isResponseExpanded ? <ChevronUp /> : <ChevronDown />}
                                                                </div>
                                                            </div>
                                                            
                                                            {isResponseExpanded && item.details.length > 0 && (
                                                                <div style={styles.accordionContent}>
                                                                    <h6 style={{ fontSize: '14px', fontWeight: '600', marginBottom: '12px' }}>
                                                                        Respondents who selected "{item.response}" ({item.count} total)
                                                                    </h6>
                                                                    
                                                                    <div style={{ overflowX: 'auto' }}>
                                                                        <table style={styles.responseTable}>
                                                                            <thead>
                                                                                <tr style={styles.responseTableHeader}>
                                                                                    <th style={styles.responseTableCell}>Name</th>
                                                                                    <th style={styles.responseTableCell}>Client</th>
                                                                                    <th style={styles.responseTableCell}>Role</th>
                                                                                    <th style={styles.responseTableCell}>BU</th>
                                                                                    <th style={styles.responseTableCell}>Email</th>
                                                                                    {item.details[0]?.specificValue && (
                                                                                        <th style={styles.responseTableCell}>Specific Value</th>
                                                                                    )}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {item.details.map((detail, detailIndex) => (
                                                                                    <tr key={detailIndex} style={styles.responseTableRow}>
                                                                                        <td style={styles.responseTableCell}>
                                                                                            <strong>{detail.firstName} {detail.lastName}</strong>
                                                                                        </td>
                                                                                        <td style={styles.responseTableCell}>{detail.client}</td>
                                                                                        <td style={styles.responseTableCell}>{detail.function}</td>
                                                                                        <td style={styles.responseTableCell}>{detail.bu}</td>
                                                                                        <td style={styles.responseTableCell}>{detail.email}</td>
                                                                                        {detail.specificValue && (
                                                                                            <td style={styles.responseTableCell}>{detail.specificValue}</td>
                                                                                        )}
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        
                                        <div>
                                            <h5 style={{ fontSize: '14px', fontWeight: '600', marginBottom: '12px' }}>Visual Distribution</h5>
                                            {renderQuestionVisual(questionData, questionInfo)}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

  const currentData = getFilteredData();
  const questionStats = calculateQuestionStats();
  const buFunctionAnalysis = getBuFunctionAnalysis();
  const clientWiseData = getClientWiseData();

  const getResponseTypeData = () => {
    return [
      { name: 'Completed Surveys', value: currentData.totalSurveyReceived, color: '#10b981' },
      { name: 'Non-Responders', value: currentData.totalNonResponders, color: '#f59e0b' },
      { name: 'Technical Issues', value: currentData.totalTechnicalIssues, color: '#ec4899' }
    ];
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '14px', color: '#6b7280' }}></div>
            <div style={{ fontSize: '8px', fontWeight: '700', color: '#374151', width: '120px', height: 'auto'}}>
              <img 
                src='https://github.com/Sweety-Vigneshg/Vdart_Asset_Images/blob/main/vdartorginallogo.png?raw=true' 
                style={styles.logo} 
                alt="VDart Logo"
              />
            </div>
          </div>
          <div>
            <h1 style={styles.title}>
              VDart Client Satisfaction Dashboard 
              {/* <TrendingUp style={{ width: '32px', height: '32px', color: '#2563eb', marginLeft: '12px', display: 'inline-block' }} /> */}
            </h1>
            <p style={styles.subtitle}>Real-time insights into client feedback and satisfaction</p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
            <div style={{ textAlign: 'center' }}>
            </div>
          </div>
        </div>
      </div>

      <div style={styles.mainContent}>
        {/* Controls */}
        <div style={styles.controlsCard}>
          <div style={styles.controlsHeader}>
            <div style={styles.controlsTitle}>
              <div style={{ ...styles.iconContainer, backgroundColor: '#e0e7ff' }}>
                <Settings style={{ width: '20px', height: '20px', color: '#7c3aed' }} />
              </div>
              <div>
                <h3 style={styles.sectionTitle}>
                  Dashboard Controls 
                  {/* <Activity style={{ width: '16px', height: '16px', color: '#7c3aed', marginLeft: '8px', display: 'inline-block' }} /> */}
                </h3>
                <p style={{ color: '#6b7280' }}>Filter and customize your view</p>
              </div>
            </div>
            <div style={styles.viewButtons}>
              <button 
                style={{
                  ...styles.viewButton,
                  ...(selectedView === 'overview' ? styles.viewButtonActive : styles.viewButtonInactive)
                }}
                onClick={() => setSelectedView('overview')}
              >
                <TrendingUp style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                Overview
              </button>
              <button 
                style={{
                  ...styles.viewButton,
                  ...(selectedView === 'bu-function' ? styles.viewButtonActive : styles.viewButtonInactive)
                }}
                onClick={() => setSelectedView('bu-function')}
              >
                <Award style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                BU & Function Analysis
              </button>
              <button 
                style={{
                  ...styles.viewButton,
                  ...(selectedView === 'client-wise' ? styles.viewButtonActive : styles.viewButtonInactive)
                }}
                onClick={() => setSelectedView('client-wise')}
              >
                <Target style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                Client Analysis
              </button>
              <button 
                style={{
                  ...styles.viewButton,
                  ...(selectedView === 'detailed-analysis' ? styles.viewButtonActive : styles.viewButtonInactive)
                }}
                onClick={() => setSelectedView('detailed-analysis')}
              >
                <Eye style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                Detailed Analysis
              </button>
            </div>
          </div>
          
          <div style={styles.filterGrid}>
            <div style={styles.filterGroup}>
              <label style={styles.filterLabel}>Business Unit</label>
              <select 
                style={styles.filterSelect}
                value={selectedFilter.bu}
                onChange={(e) => setSelectedFilter({...selectedFilter, bu: e.target.value})}
              >
                <option value="All">All Business Units</option>
                <option value="Oliver">Oliver BU (97 contacts)</option>
                <option value="Rohit">Rohit BU (58 contacts)</option>
                <option value="Nambu">Nambu BU (48 contacts)</option>
                <option value="Sidd">Sidd BU (48 contacts)</option>
              </select>
            </div>
            <div style={styles.filterGroup}>
              <label style={styles.filterLabel}>Department</label>
              <select 
                style={styles.filterSelect}
                value={selectedFilter.department}
                onChange={(e) => setSelectedFilter({...selectedFilter, department: e.target.value})}
              >
                <option value="All">All Departments</option>
                <option value="Tag Lead">Tag Lead</option>
                <option value="Procurement">Procurement</option>
              </select>
            </div>
            <div style={styles.filterGroup}>
              
            </div>
          </div>
        </div>

        {selectedView === 'overview' ? (
          <>
            {/* KPI Cards */}
            <div style={styles.kpiGrid}>
              <KPICard 
                title="Total Surveys Sent" 
                value={currentData.totalSurveySent.toLocaleString()} 
                icon={Send}
                color="blue"
                subtitle="Based on actual Excel records"
              />
              <KPICard 
                title="Completed Surveys" 
                value={currentData.totalSurveyReceived.toLocaleString()} 
                icon={MessageSquare}
                color="green"
                subtitle="Successfully completed"
                onClick={true}
                detailType="Survey Responded"
              />
              <KPICard 
                title="Non-Responders" 
                value={currentData.totalNonResponders.toLocaleString()} 
                icon={Users}
                color="orange"
                subtitle="No response received"
                onClick={true}
                detailType="Survey Not responded"
              />
              <KPICard 
                title="Technical Issues" 
                value={currentData.totalTechnicalIssues.toLocaleString()} 
                icon={AlertTriangle}
                color="red"
                subtitle="Technical problems"
                onClick={true}
                detailType="Technical issue"
              />
              <KPICard 
                title="Response Rate" 
                value={`${currentData.responseRate.toFixed(1)}%`} 
                icon={Target}
                color="purple"
                subtitle="Overall completion rate"
              />
              <KPICard 
                title="Avg Satisfaction" 
                value={`${(questionStats["How well does VDart understand your staffing requirements and expectations?"]?.avgScore || 0).toFixed(1)}/5`} 
                icon={Heart}
                color="pink"
                subtitle="Client satisfaction score"
              />
            </div>

            {/* Charts Section */}
            <div style={{ marginBottom: '32px' }}>
              <FunctionWiseChart />
            </div>

            {/* NPS Section */}
            <NPSCard data={questionStats["How likely is it that you would recommend VDart to a friend or colleague?"]} />

            {/* Survey Question Analysis */}
            <div style={styles.sectionCard}>
              <div style={styles.sectionHeader}>
                <div style={styles.controlsTitle}>
                  <div style={{ ...styles.iconContainer, backgroundColor: '#e0e7ff' }}>
                    <BarChart3 style={{ width: '20px', height: '20px', color: '#7c3aed' }} />
                  </div>
                  <div>
                    <h3 style={styles.sectionTitle}>
                      Survey Question Analysis 
                      <FileText style={{ width: '16px', height: '16px', color: '#7c3aed', marginLeft: '8px', display: 'inline-block' }} />
                    </h3>
                    <p style={{ color: '#6b7280' }}>Detailed breakdown of all survey questions</p>
                  </div>
                </div>
              </div>
              
              <div style={styles.questionGrid}>
                {Object.entries(questionStats).filter(([key]) => key !== "How likely is it that you would recommend VDart to a friend or colleague?").map(([question, data]) => (
                  <div key={question} style={styles.questionCard}>
                    <h4 style={styles.questionTitle}>{data.shortTitle}</h4>
                    <p style={styles.questionSubtitle}>{surveyQuestions[question]?.question}</p>
                    
                    <div style={styles.questionScore}>
                      <div style={styles.questionScoreValue}>{data.avgScore.toFixed(1)}</div>
                      <div style={styles.questionScoreLabel}>Average Score</div>
                    </div>
                    
                    <div style={styles.questionResponses}>
                      {Object.entries(data.responses).map(([rating, count]) => (
                        <div key={rating} style={styles.questionResponse}>
                          <div style={styles.questionResponseLabel}>
                            <span>{rating}</span>
                            {rating !== "NA" && (
                              <div style={styles.starContainer}>
                                {[...Array(parseInt(rating.split(' ')[0]))].map((_, i) => (
                                  <Star key={i} style={{ ...styles.star, fill: '#fbbf24', color: '#fbbf24' }} />
                                ))}
                              </div>
                            )}
                          </div>
                          <span 
                            style={styles.questionResponseValue}
                            onClick={() => {
                              setSelectedSurveyQuestion(question);
                              setSelectedRating(rating);
                              setShowDetailModal(true);
                            }}
                            onMouseEnter={(e) => e.target.style.color = '#1d4ed8'}
                            onMouseLeave={(e) => e.target.style.color = '#2563eb'}
                          >
                            {count}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        ) : selectedView === 'bu-function' ? (
          <div style={styles.sectionCard}>
            <div style={styles.sectionHeader}>
              <div style={styles.controlsTitle}>
                <div style={{ ...styles.iconContainer, backgroundColor: '#dbeafe' }}>
                  <Building2 style={{ width: '20px', height: '20px', color: '#2563eb' }} />
                </div>
                <div>
                  <h3 style={styles.sectionTitle}>
                    Business Unit & Function Analysis 
                    <Building2 style={{ width: '16px', height: '16px', color: '#2563eb', marginLeft: '8px', display: 'inline-block' }} />
                  </h3>
                  <p style={{ color: '#6b7280' }}>Detailed breakdown by BU and function</p>
                </div>
              </div>
            </div>
            
            <div style={styles.functionButtons}>
              <button 
                style={{
                  ...styles.functionButton,
                  ...(selectedFunctionType === 'All' ? styles.functionButtonActive : styles.functionButtonInactive)
                }}
                onClick={() => setSelectedFunctionType('All')}
              >
                All Functions
              </button>
              <button 
                style={{
                  ...styles.functionButton,
                  ...(selectedFunctionType === 'Tag Lead' ? styles.functionButtonActive : styles.functionButtonInactive)
                }}
                onClick={() => setSelectedFunctionType('Tag Lead')}
              >
                Tag Lead
              </button>
              <button 
                style={{
                  ...styles.functionButton,
                  ...(selectedFunctionType === 'Procurement' ? styles.functionButtonActive : styles.functionButtonInactive)
                }}
                onClick={() => setSelectedFunctionType('Procurement')}
              >
                Procurement
              </button>
            </div>
            
            <div style={styles.buGrid}>
              {Object.entries(buFunctionAnalysis).filter(([key, data]) => 
                selectedFunctionType === 'All' || data.function === selectedFunctionType
              ).map(([key, data]) => (
                <div key={key} style={styles.buCard}>
                  <div style={styles.buHeader}>
                    <h4 style={styles.buTitle}>{data.bu} BU - {data.function}</h4>
                    <div style={styles.buResponseRate}>{data.responseRate.toFixed(1)}%</div>
                    <div style={{ fontSize: '12px', color: '#6b7280' }}>Response Rate</div>
                  </div>
                  
                  <div style={styles.buMetrics}>
                    <div style={styles.buMetricRow}>
                      <span style={styles.buMetricLabel}>Total Sent</span>
                      <span style={{ ...styles.buMetricValue, color: '#2563eb' }}>{data.totalSent}</span>
                    </div>
                    <div style={styles.buMetricRow}>
                      <span style={styles.buMetricLabel}>Completed</span>
                      <span style={{ ...styles.buMetricValue, color: '#16a34a' }}>{data.surveyCompleted}</span>
                    </div>
                    <div style={styles.buMetricRow}>
                      <span style={styles.buMetricLabel}>Non-Responders</span>
                      <span style={{ ...styles.buMetricValue, color: '#f97316' }}>{data.nonResponders}</span>
                    </div>
                    <div style={styles.buMetricRow}>
                      <span style={styles.buMetricLabel}>Technical Issues</span>
                      <span style={{ ...styles.buMetricValue, color: '#ef4444' }}>{data.technicalIssues}</span>
                    </div>
                  </div>
                  
                  <div style={styles.progressBar}>
                    <div 
                      style={{
                        ...styles.progressFill,
                        width: `${Math.min(data.responseRate, 100)}%`,
                        backgroundColor: data.responseRate >= 30 ? '#22c55e' : 
                                       data.responseRate >= 20 ? '#eab308' : 
                                       data.responseRate >= 10 ? '#f97316' : '#ef4444'
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : selectedView === 'client-wise' ? (
          <div style={styles.sectionCard}>
            <div style={styles.sectionHeader}>
              <div style={styles.controlsTitle}>
                <div style={{ ...styles.iconContainer, backgroundColor: '#dcfce7' }}>
                  <Users style={{ width: '20px', height: '20px', color: '#16a34a' }} />
                </div>
                <div>
                  <h3 style={styles.sectionTitle}>
                    Client-wise Analysis 
                    <Users style={{ width: '16px', height: '16px', color: '#16a34a', marginLeft: '8px', display: 'inline-block' }} />
                  </h3>
                  <p style={{ color: '#6b7280' }}>Detailed breakdown by client organization</p>
                </div>
              </div>
            </div>
            
            <div style={styles.clientGrid}>
              {Object.entries(clientWiseData).map(([client, data]) => (
                <div key={client} style={styles.clientCard}>
                  <h4 style={styles.clientTitle}>{client}</h4>
                  
                  <div style={styles.clientStats}>
                    <div style={styles.clientStat}>
                      <div style={{ ...styles.clientStatValue, color: '#2563eb' }}>{data.totalSent}</div>
                      <div style={styles.clientStatLabel}>Total Sent</div>
                    </div>
                    <div style={styles.clientStat}>
                      <div style={{ ...styles.clientStatValue, color: '#16a34a' }}>{data.completed}</div>
                      <div style={styles.clientStatLabel}>Completed</div>
                    </div>
                    <div style={styles.clientStat}>
                      <div style={{ ...styles.clientStatValue, color: '#f97316' }}>{data.nonResponders}</div>
                      <div style={styles.clientStatLabel}>Non-Responders</div>
                    </div>
                    <div style={styles.clientStat}>
                      <div style={{ ...styles.clientStatValue, color: '#ef4444' }}>{data.technicalIssues}</div>
                      <div style={styles.clientStatLabel}>Technical Issues</div>
                    </div>
                  </div>
                  
                  <div style={{ marginBottom: '12px' }}>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '4px' }}>
                      Response Rate: {data.responseRate.toFixed(1)}%
                    </div>
                    <div style={styles.progressBar}>
                      <div 
                        style={{
                          ...styles.progressFill,
                          width: `${Math.min(data.responseRate, 100)}%`,
                          backgroundColor: data.responseRate >= 30 ? '#22c55e' : 
                                         data.responseRate >= 20 ? '#eab308' : 
                                         data.responseRate >= 10 ? '#f97316' : '#ef4444'
                        }}
                      ></div>
                    </div>
                  </div>
                  
                  <ClientWiseChart data={data} />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <DetailedAnalysisAccordion />
        )}
      </div>

      <DetailModal 
        isOpen={showDetailModal}
        onClose={() => setShowDetailModal(false)}
        detailType={selectedDetailType}
        question={selectedSurveyQuestion}
        rating={selectedRating}
      />
    </div>
  );
};

export default VDartSatisfactionDashboard
